//
import React, { Component, Fragment } from "react";
import { Button, Row, Col, InputGroup, Alert } from "reactstrap";

import ReactTooltip from "react-tooltip";

import { WorkOrderForm } from "./WorkOrderForm";
import { WorkOrderTableDefault } from "./WorkOrderTableDefault";
import { WorkOrderTableFinalConfirmation } from "./WorkOrderTableFinalConfirmation";
import { WorkOrderTablePurpleReport } from "./WorkOrderTablePurpleReport";
import { WorkOrderTablePending } from "./WorkOrderTablePending";
import { WorkOrderTableCallback } from "./WorkOrderTableCallback";
import { WorkOrderTableContract } from "./WorkOrderTableContract";
import { WorkOrderTableAudit } from "./WorkOrderTableAudit";
import { WorkOrderTableMyJobs } from "./WorkOrderTableMyJobs";
import { WorkOrderTableDeletedJobs } from "./WorkOrderTableDeletedJobs";
import { WorkOrderTableConfirmation } from "./WorkOrderTableConfirmation";
import { WorkOrderTableBooking } from "./WorkOrderTableBooking";
import { WorkOrderTableAuthTransport } from "./WorkOrderTableAuthTransport";
import { WorkOrderTableRemote } from "./WorkOrderTableRemote";

import { WorkOrderCopyJob } from "./WorkOrderCopyJob";

import { LoadingModal } from "./LoadingModal";
import { NewWorkOrderModel } from "./utils/NewWorkOrderModel";
import { WorkOrderJobNotes } from "./WorkOrderJobNotes";
import { InterpreterForm } from "./InterpreterForm";
import { WorkOrderAddJobNotes } from "./WorkOrderAddJobNotes";

import { FetchData, FetchFile } from "./utils/DataFetch";
import { GetParameterByName, GetCookie, Timeout, openFileInNewTab } from "./utils/Common";
import { buildAuthEmailSubject, buildAuthEmailSubjectMulti, buildAuthEmailBodyMulti, buildRepIconEmailBody } from "./utils/authEmailUtils";

import { InterpreterFormEmail } from "./InterpreterFormEmail";
import { RepFormEmail } from "./RepFormEmail";
import { ProviderFormEmail } from "./ProviderFormEmail";

import AddIcon from "../images/add.png";
import RefreshIcon from "../images/merge-icon.png";

import Previous from "../images/prev.png";
import Next from "../images/next.png";

import { WorkOrderIntConfNo } from "./WorkOrderIntConfNo";

const moment = require("moment");

const PORTAL_URL = process.env.REACT_APP_PORTAL_URL || window.location.origin;

export class WorkOrder extends Component {
  static displayName = WorkOrder.name;

  constructor(props) {
    super(props);

    let tableView = props.TableView;

    this.state = {
      currentSelection: false,
      dayNames: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],

      workOrderList: [],
      deletedJobsList: [],
      jobHistoryList: [],
      jobInvLineList: [],
      clientForEmail: null,
      purpleJobHistoryLoading: false,

      executiveUsers: [],

      receivableList: [],
      receivableItemList: [],

      loading: true,

      modal: false,
      fetchingData: false,
      modalIntFormEmail: false,
      modalRepFormEmail: false,
      modalProviderFormEmail: false,
      modalWOJobNotes: false,
      modalInterpreter: false,
      modalAddJobNote: false,
      modalCopyJob: false,
      modalDeletedJob: false,
      modalDJJobHistory: false,

      multiFilter: false,

      selectedIndex: -1,
      selectedJob: null,

      isFollowup: false,
      followupOriginjobId: null,

      checkAll: false,
      alert: {
        color: "info",
        message: "",
        isOpen: false,
      },
      model: {
        EventType: "insert",
        JobNum: 0,
        JobId: null,
        JobDateTime: null,
        JobTime: null,
        FinishTime: null,
        FinishTimeString: null,
        FollowupDate: null,
        ProvId: null,
        ProviderName: "",
        ConfCallNote: "",
        AptName: "",
        AptStreet: "",
        AptCity: "",
        AptState: "",
        AptZip: "",
        AptPhone: "",
        AptDirection: "",
        FailedFlg: false,
        CallerNote: "",
        InvoiceNote: "",
        IntCheckDate: null,
        IntCheckNum: null,
        InvoicedFlg: false,
        JobTotal: null,
        JobDiscount: null,
        IntFee: null,
        IntFeeOther: null,
        IntOTFee: null,
        IntFeeNote: "",
        TransportationFlg: false,
        TransConfFlg: false,
        IntConfFlg: false,
        IntFinalConfEmailSentFlg: false,
        AppointmentTypeId: "9e5e4810-c5a8-428b-8f7d-71422b6b77e3", // conf call
        CallerType: null,
        ProvConfFlg: false,
        ClmConfFlg: true,
        IsDeletedFlg: false,
        BillReviewedFlg: false,
        AuditFlg: false,
        PurpleReportFlg: false,
        RepAuthorizedFlg: false,
        SelectedFlg: false,
        ClmId: "",
        ClmFirstName: "",
        ClmLastName: "",
        ClmClaimNumber: "",
        ClmClaimNumberNoDash: "",
        ClmPhone: "",
        ClmDateOfLoss: "",
        ClmDateOfInjury: "",
        ClmDateOfInjuryStart: null,
        ClmDateOfInjuryEnd: null,
        ClmDateOfLossDate: null,
        ClmNote: "",
        ClmDOB: null,
        ClmInsuredParty: "",
        ClmEmployer: "",
        ClmInvoiceCaption: "",
        ClmLanguage: "",
        ClmWCABNumber: "",
        ClmInvoiceType: "",
        ClmStreet: "",
        ClmCity: "",
        ClmState: "",
        ClmZip: "",
        ClmSSN: "",
        ClmOrderedByName: "",
        ClmDiagnosis: "",
        ClmEmail: "",
        ClmHasAttorneyFlg: false,
        RepId: null,
        RepFirstName: "",
        RepLastName: "",
        RepPhone: "",
        RepEmail: "",
        ClientId: "",
        ClientAbbrv: "",
        ClientName: "",
        ClientStreet: "",
        ClientStreet2: "",
        ClientCity: "",
        ClientState: "",
        ClientZip: "",
        ClientMailStreet: "",
        ClientMailStreet2: "",
        ClientMailCity: "",
        ClientMailState: "",
        ClientMailZip: "",
        ClientPhone: "",
        ClientPhoneFax: "",
        ClientPhone2: "",
        ClientEmail: "",
        ClientInactiveFlg: false,
        IntId: null,
        IntLastName: "",
        IntFirstName: "",
        IntCellTxt: "",
        IntPhoneOnly: "",
        IntEmail: "",
        IntNote: "",
        InHouseFlg: false,
        IntCity: "",
        IntStreet: "",
        IntState: "",
        IntZip: "",
        DBA: "",
        Rate: 0,
        HourMinimum: 0,
        Prorate: "",
        BankRoute: "",
        BankAccount: "",
        IntSSINumber: "",
        FirstName: "",
        LastName: "",
        UserType: "",
        UserIntId: null,
        CreateDateTime: null,
        CreateByUserId: null,
        RemIntFlg: false,
        RemClaimFlg: false,
        RemProvFlg: false,
        RemFinalFlg: false,
        RemType: null,
        RemTypeDesc: "",
        RemHost: null,
        RemHostDesc: "",
        CreatedBy: "",
        UpdatedBy: "",
        MyJobTJobHistory: "",
        MyJobWaitingOnCallBack: "",
        JobBalance: null,
        DeletedOn: null,
        WorkFlowId: "",
        JobTypeName: "",
      },
      client: {
        EventType: "update",
        ClientId: null,
        ClientAbbrv: "",
        ClientPhone: "",
        ClientPhone2: "",
        ClientPhoneFax: "",
        ClientName: "",
        ClientMailStreet: "",
        ClientMailStreet2: "",
        ClientMailCity: "",
        ClientMailState: "",
        ClientMailZip: "",
        ClientStreet: "",
        ClientStreet2: "",
        ClientCity: "",
        ClientState: "",
        ClientZip: "",
        ClientCountry: "",
        ClientDiscount: null,
        ClientNotes: "",
        ClientCreditCard: "",
        ClientEmailForInvoice: "",
        ClientEmail: "",
        ClientWebsite: "",
        ClientOrg: "",
        ClientBillRateType: "",
        ClientInactiveFlg: false,
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
      },
      interpreter: {
        EventType: "insert",
        IntId: null,
        IntLastName: "",
        IntFirstName: "",
        IntGender: "",
        IntPronoun: "",
        IntEmail: "",
        IntCellTxt: "",
        IntPhoneOnly: "",
        IntFax: "",
        IntBeeper: "",
        IntStreet: "",
        IntCity: "",
        IntState: "",
        IntZip: "",
        IntCountry: "",
        IntSSINumber: "",
        IntActiveFlg: false,
        IntCorporationFlg: false,
        DBA: "",
        InHouseFlg: false,
        UnVettedFlg: false,
        EmergencyContact: "",
        UnavailableReason: "",
        BankName: "",
        BankAccount: "",
        BankRoute: "",
        Rate: null,
        HourMinimum: null,
        Prorate: "",
        ConfCallRate: null,
        BusinessCardRequestDate: null,
        BusinessCardRequestToProcessFlg: false,
        IntNote: "",
        ReferredBy: "",
        DefaultLanguage: "",
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        CreatedBy: "",
        UpdatedBy: "",
      },
      searchModel: {
        IntId: "",
        ClmId: "",
        JobNum: null,
        StartDate:
          props.TableView === "pending"
            ? moment().format("YYYY-MM-DD")
            : props.WorkFlowId === ""
              ? WorkOrder.initialStartDate(props)
              : "",
        EndDate: "",
        Claimant: "",
        ClmClaimNumberNoDash: "",
        CLMPhone: "",
        Interpreter: "",
        Rep: "",
        ClientAbbrv: "",
        ProviderName: "",
        CreatedByUserId: null,
        MyJobs: false,
        MyJobsUserId: props.CurrentUser,
        WorkFlowId: props.WorkFlowId,
      },
      email: {
        EmailFrom: "",
        EmailTo: "",
        EmailCC: "",
        Subject: "",
        Body: "",
        JobIds: "",
        EmailSource: "",
      },
      jobNotes: {
        JobNumbers: "",
        Type: "",
        Description: "",
        JobHistory: [],
      },

      showButtons: "cancellation,remote_email,covering_email",
      tableView: tableView,

      modalEmailConfirm: false,
      emailConfirm: {
        notify_type: "",
        JobId: null,
        IntId: null,
      },
    };

    this.manualDateInput = {
      StartDate: false,
      EndDate: false,
    };
    //
    this.user = JSON.parse(GetCookie("user"));
    this.containerRef = React.createRef();

    // Core Form Functionality
    this.keydownHandler = this.keydownHandler.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.resetFields = this.resetFields.bind(this);
    this.setData = this.setData.bind(this);
    this.setDataNextPrev = this.setDataNextPrev.bind(this);
    this.setJobData = this.setJobData.bind(this);
    this.setNextPrevData = this.setNextPrevData.bind(this);
    this.handlePrevNextButton = this.handlePrevNextButton.bind(this);
    this.refreshWorkOrderData = this.refreshWorkOrderData.bind(this);
    this.handleWorkOrderModelChange =
      this.handleWorkOrderModelChange.bind(this);

    // Modal Management
    this.setModal = this.setModal.bind(this);
    this.setModalDJJobHistory = this.setModalDJJobHistory.bind(this);
    this.setModalIntFormEmail = this.setModalIntFormEmail.bind(this);
    this.setModalRepFormEmail = this.setModalRepFormEmail.bind(this);
    this.setModalProviderFormEmail = this.setModalProviderFormEmail.bind(this);
    this.setModalWOJobNotes = this.setModalWOJobNotes.bind(this);
    this.setModalEmailConfirm = this.setModalEmailConfirm.bind(this);
    this.setModalInterpreter = this.setModalInterpreter.bind(this);
    this.setModalAddJobNote = this.setModalAddJobNote.bind(this);
    this.setModalCopyJob = this.setModalCopyJob.bind(this);

    // Search and Filter
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSearchFocus = this.handleSearchFocus.bind(this);
    this.handleSearchBlur = this.handleSearchBlur.bind(this);
    this.refreshSearch = this.refreshSearch.bind(this);

    // Checkbox Handling
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.unCheckAll = this.unCheckAll.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.resetChecks = this.resetChecks.bind(this);
    this.handleClearChecksOnEmailModalClose =
      this.handleClearChecksOnEmailModalClose.bind(this);

    // Job Management
    this.confirmActivation = this.confirmActivation.bind(this);
    this.handlePiggyBack = this.handlePiggyBack.bind(this);
    this.handleAutoPay = this.handleAutoPay.bind(this);
    this.handleCopyJob = this.handleCopyJob.bind(this);
    this.addSchedule = this.addSchedule.bind(this);

    // Email and Communication
    this.setInterpreterEmail = this.setInterpreterEmail.bind(this);
    this.setRepEmail = this.setRepEmail.bind(this);
    this.setRepEmail2 = this.setRepEmail2.bind(this);
    this.setProviderEmail = this.setProviderEmail.bind(this);
    this.handleRepEmailClick = this.handleRepEmailClick.bind(this);
    this.handleRepAuthorizationsClick = this.handleRepAuthorizationsClick.bind(this);
    this.handleIntEmailClick = this.handleIntEmailClick.bind(this);
    this.handleIntCheckin = this.handleIntCheckin.bind(this);
    this.handleIntConfNo = this.handleIntConfNo.bind(this);
    this.handleSendSMS = this.handleSendSMS.bind(this);
    this.openInterpreter = this.openInterpreter.bind(this);

    // Data Fetching and Population
    this.getJobHistory = this.getJobHistory.bind(this);
    this.getJobInvLine = this.getJobInvLine.bind(this);
    this.getClientForRepEmail = this.getClientForRepEmail.bind(this);
    this.populateWorkOrderDataRefresh =
      this.populateWorkOrderDataRefresh.bind(this);
    this.populateDeletedJobsData = this.populateDeletedJobsData.bind(this);
    this.populateWorkOrderData = this.populateWorkOrderData.bind(this);
    this.populateWorkOrderCallbackData =
      this.populateWorkOrderCallbackData.bind(this);
    this.populateExecutiveUsers = this.populateExecutiveUsers.bind(this);
    this.populateWorkOrderPurpleReportData =
      this.populateWorkOrderPurpleReportData.bind(this);
    this.populateWorkOrderPendingData =
      this.populateWorkOrderPendingData.bind(this);

    // Event Success Handlers
    this.handleSaveEventIntEmailSuccess =
      this.handleSaveEventIntEmailSuccess.bind(this);
    this.handleSaveEventRepEmailSuccess =
      this.handleSaveEventRepEmailSuccess.bind(this);
    this.handleSaveEventProviderEmailSuccess =
      this.handleSaveEventProviderEmailSuccess.bind(this);
    this.handleSaveEventInterpreterSuccess =
      this.handleSaveEventInterpreterSuccess.bind(this);
    this.handleSaveEventEmailConfirmSuccess =
      this.handleSaveEventEmailConfirmSuccess.bind(this);
    this.handleCoveringEmailSent = this.handleCoveringEmailSent.bind(this);
    this.handleSaveEventJobNotesSuccess =
      this.handleSaveEventJobNotesSuccess.bind(this);
    this.handleSortedData = this.handleSortedData.bind(this);
    this.handleSortedDeletedJobs = this.handleSortedDeletedJobs.bind(this);
    this.handleSaveEventCopyJobSuccess =
      this.handleSaveEventCopyJobSuccess.bind(this);

    // View and Render Methods
    this.viewJobHistory = this.viewJobHistory.bind(this);
    this.viewJobNotes = this.viewJobNotes.bind(this);
    this.viewInvoice = this.viewInvoice.bind(this);
    this.exportPDF = this.exportPDF.bind(this);
    this.handleAddJobNoteClick = this.handleAddJobNoteClick.bind(this);
    this.setFetchingData = this.setFetchingData.bind(this);
    this.renderContent = this.renderContent.bind(this);

    // Table Rendering
    this.renderWorkOrderTableDefault =
      this.renderWorkOrderTableDefault.bind(this);
    this.renderWorkOrderTableBooking =
      this.renderWorkOrderTableBooking.bind(this);
    this.renderWorkOrderTableAuthTransport =
      this.renderWorkOrderTableAuthTransport.bind(this);
    this.renderWorkOrderTableConfirmation =
      this.renderWorkOrderTableConfirmation.bind(this);
    this.renderWorkOrderTableMyJobs =
      this.renderWorkOrderTableMyJobs.bind(this);
    this.renderWorkOrderTablePurpleReport =
      this.renderWorkOrderTablePurpleReport.bind(this);
    this.renderWorkOrderTablePending =
      this.renderWorkOrderTablePending.bind(this);
    this.renderWorkOrderTableCallback =
      this.renderWorkOrderTableCallback.bind(this);
    this.renderWorkOrderTableContract =
      this.renderWorkOrderTableContract.bind(this);
    this.renderWorkOrderTableAudit = this.renderWorkOrderTableAudit.bind(this);
    this.renderWorkOrderTableDeletedJobs =
      this.renderWorkOrderTableDeletedJobs.bind(this);

    this.handlePurpleHistoryLoadingChange =
      this.handlePurpleHistoryLoadingChange.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.keydownHandler);
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div",
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay",
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });

    if (this.props.TableView === "callback") {
      this.populateWorkOrderCallbackData();
    } else if (this.props.TableView === "deletedjobs") {
      this.populateDeletedJobsData();
    } else if (this.props.TableView === "remote") {
      const today = moment().format("YYYY-MM-DD");
      this.setState(
        (prevState) => {
          const existingStart = prevState.searchModel.StartDate;
          const parsedStart = existingStart ? moment(existingStart) : null;

          return {
            searchModel: {
              ...prevState.searchModel,
              StartDate:
                existingStart && parsedStart && parsedStart.isValid()
                  ? parsedStart.format("YYYY-MM-DD")
                  : today,
            },
          };
        },
        () => this.populateWorkOrderRemoteData(),
      );
    } else if (this.props.TableView === "finalconf") {
      this.populateWorkOrderFinalConfirmationData();
    } else if (this.props.TableView === "purplereport") {
      this.populateWorkOrderPurpleReportData();
    } else if (this.props.TableView === "pending") {
      const today = moment().format("YYYY-MM-DD");
      this.setState(
        (prevState) => ({
          searchModel: {
            ...prevState.searchModel,
            StartDate: today,
          },
        }),
        () => this.populateWorkOrderPendingData(),
      );
    } else {
      this.populateWorkOrderData();
      if (this.props.isMyJob) this.populateExecutiveUsers();

      if (GetParameterByName("jobid") !== null)
        this.openWorkOrderForm(GetParameterByName("jobid"));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    document.addEventListener("keydown", this.keydownHandler);

    ReactTooltip.rebuild();

    if (this.state.clearSelection && !prevState.clearSelection) {
      this.setState({ clearSelection: false });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keydownHandler);
    // Any additional cleanup can be done here
  }

  confirmActivation(e) {
    let model = { ...this.state.searchModel };
    let userModel = { ...this.user };
    if (
      this.state.searchModel.JobNum !== null &&
      this.state.searchModel.JobNum !== ""
    ) {
      var note = window.prompt("Why are you re-activating this job?", "");
      if (note !== null) {
        var data = {
          JobNum: model.JobNum,
          UserId: userModel.userid,
          Note: note,
        };

        FetchData("/undelete", "POST", this.user.token, data).then((data) => {
          this.handleSaveEventSuccess({
            message: data,
            model: data === "Success" ? false : true,
            color: data === "Success" ? "success" : "warning",
          });
        });
      }
    } else {
      window.confirm("Please enter a Job Number to re-activate");
    }
  }

  setModalDJJobHistory() {
    this.setState({ modalDJJobHistory: !this.state.modalDJJobHistory });
  }

  viewJobHistory(deletedJob) {
    FetchData("/getJobHistory", "POST", this.user.token, {
      JobId: deletedJob.jobId,
    }).then((data) => {
      this.setState({ jobHistoryList: data });
    });
    this.setModalDJJobHistory();
  }

  keydownHandler(e) {
    if (
      this.containerRef.current &&
      this.containerRef.current.offsetParent === null
    ) {
      return;
    }
    if (e.keyCode === 74 && e.altKey && this.state.modal === false) {
      // ALT + J
      this.JobNum.focus();
    } else if (e.keyCode === 76 && e.altKey && this.state.modal === false) {
      // ALT + L
      this.ClmClaimNumberNoDash.focus();
    } else if (e.keyCode === 84 && e.altKey && this.state.modal === false) {
      // ALT + T
      this.CLMPhone.focus();
    } else if (e.keyCode === 65 && e.altKey && this.state.modal === false) {
      // ALT + A
      this.ClientAbbrv.focus();
    } else if (e.keyCode === 73 && e.altKey && this.state.modal === false) {
      // ALT + I
      this.Interpreter.focus();

      let interpreterName = "";
      let intId = "";

      this.state.workOrderList.forEach((item) => {
        if (this.state["chk_" + item.jobNum]) {
          interpreterName = `${item.intLastName.split(" ")[0]} ${
            item.intFirstName
          }`;
          intId = `${item.intId}`;
        }
      });

      this.setState(
        (prevState) => ({
          searchModel: {
            ...prevState.searchModel,
            IntId: intId,
            Interpreter: interpreterName,
          },
        }),
        () => {
          this.refreshSearch();
        },
      );
    } else if (e.keyCode === 67 && e.altKey && this.state.modal === false) {
      // ALT + C
      this.Claimant.focus();

      let clmId = "";

      this.state.workOrderList.forEach((item) => {
        if (this.state["chk_" + item.jobNum]) {
          clmId = item.clmId;
        }
      });

      this.setState(
        (prevState) => ({
          searchModel: {
            ...prevState.searchModel,
            ClmId: clmId,
            ClmClaimNumberNoDash: "",
            clmClaimNumberNoDash: "",
            Claimant: "",
          },
        }),
        () => {
          this.refreshSearch();
        },
      );
    } else if (e.keyCode === 80 && e.altKey && this.state.modal === false) {
      // ALT + P
      this.ProviderName.focus();
    } else if (e.keyCode === 78 && e.altKey && this.state.modal === false) {
      // ALT + N
      this.resetFields();
    } else if (e.keyCode === 77 && e.altKey && this.state.modal === false) {
      // ALT + M
      const currentDate = new Date().toISOString().split("T")[0]; // Format as 'YYYY-MM-DD'
      this.setState(
        (prevState) => ({
          searchModel: {
            ...prevState.searchModel,
            Interpreter: `${this.user.lastname} ${this.user.firstname}`,
            StartDate: currentDate,
          },
        }),
        () => {
          this.refreshSearch(); // Ensure this runs after state update
        },
      );
    } else if (e.keyCode === 88 && e.altKey && this.state.modal === false) {
      // ALT + X
      this.txtStartDate.focus();
      const currentDate = new Date().toISOString().split("T")[0];
      this.setState(
        (prevState) => ({
          searchModel: {
            ...prevState.searchModel,
            StartDate: currentDate,
          },
        }),
        () => {
          this.refreshSearch();
        },
      );
    } else if (e.keyCode === 81 && e.altKey && this.state.modal === false) {
      // ALT + Q
      this.txtStartDate.focus();
      this.setState(
        (prevState) => ({
          searchModel: {
            ...prevState.searchModel,
            StartDate: "11/11/2011",
          },
        }),
        () => {
          this.refreshSearch();
        },
      );
    }
  }

  setModal() {
    this.setState(
      {
        modal: !this.state.modal,
      },
      () => {
        if (!this.state.modal) {
          this.setState({
            selectedIndex: -1,
          });
        }
      },
    );
  }

  setModalIntFormEmail() {
    this.setState({ modalIntFormEmail: !this.state.modalIntFormEmail });
  }

  setModalRepFormEmail() {
    this.setState({ modalRepFormEmail: !this.state.modalRepFormEmail });
  }

  setModalProviderFormEmail() {
    this.setState({
      modalProviderFormEmail: !this.state.modalProviderFormEmail,
    });
  }

  setModalWOJobNotes() {
    this.setState({ modalWOJobNotes: !this.state.modalWOJobNotes });
  }

  setModalEmailConfirm() {
    this.setState({ modalEmailConfirm: !this.state.modalEmailConfirm });
  }

  setModalInterpreter() {
    this.setState(
      {
        modalInterpreter: !this.state.modalInterpreter,
      },
      () => {},
    );
  }

  setModalAddJobNote() {
    this.setState({ modalAddJobNote: !this.state.modalAddJobNote });
  }

  setModalCopyJob() {
    this.setState({ modalCopyJob: !this.state.modalCopyJob });
  }

  // ?date= lets a redirect (e.g. after saving an emailed work order) open the list on that job's day.
  static initialStartDate(props) {
    const requested = props.isMyJob ? null : GetParameterByName("date");
    const parsed = requested ? moment(requested, "YYYY-MM-DD", true) : null;
    return parsed && parsed.isValid()
      ? parsed.format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
  }

  resetFields() {
    this.setState((prevState) => ({
      isFollowup: false,
      followupOriginjobId: null,
      model: NewWorkOrderModel(),
      jobHistoryList: [],
      jobInvLineList: [],
      modal: !this.state.modal,
    }));

    // this.setModal();
  }

  refreshSearch() {
    const { tableView } = this.state;

    switch (tableView) {
      case "remote":
        this.populateWorkOrderRemoteData();
        break;
      case "callback":
        this.populateWorkOrderCallbackData();
        break;
      case "pending":
        this.populateWorkOrderPendingData();
        break;
      case "purplereport":
        this.populateWorkOrderPurpleReportData();
        break;
      case "finalconf":
        this.populateWorkOrderFinalConfirmationData();
        break;
      case "deletedjobs":
        this.populateDeletedJobsData();
        break;
      default:
        this.populateWorkOrderDataRefresh();
        break;
    }
  }

  setDataNextPrev(woData, rowIndex, showModal) {
    FetchData(
      "/getworkorder?jobId=" + woData.jobId,
      "POST",
      this.user.token,
      null,
    ).then((data) => {
      this.setState((prevState) => ({
        isFollowup: false,
        followupOriginjobId: null,
        model: {
          EventType: "update",
          JobNum: data.jobNum,
          JobId: data.jobId,
          JobDateTime: data.jobDateTime,
          JobTime: data.jobTime,
          FinishTime: data.finishTime,
          FinishTimeString:
            data.finishTimeString === null ? null : data.finishTimeString,
          FollowupDate: data.followupDate,
          ProvId: data.provId,
          ProviderName: data.providerName,
          ProvEmail: data.provEmail,
          ConfCallNote: data.confCallNote,
          AptName: data.aptName,
          AptStreet: data.aptStreet,
          AptCity: data.aptCity,
          AptState: data.aptState,
          AptZip: data.aptZip,
          AptPhone: data.aptPhone,
          AptDirection: data.aptDirection,
          FailedFlg: data.failedFlg,
          CallerNote: data.callerNote,
          InvoiceNote: data.invoiceNote,
          IntCheckDate: data.intCheckDate,
          IntCheckNum: data.intCheckNum,
          InvoicedFlg: data.invoicedFlg,
          IntFinalConfEmailSentFlg:
            data.IntFinalConfEmailSentFlg ??
            data.intFinalConfEmailSentFlg ??
            data.intFinalConfEmailSendFlg ??
            false,
          JobTotal: data.jobTotal,
          JobDiscount: data.jobDiscount,
          IntFee: data.intFee === null ? null : parseInt(data.intFee),
          IntFeeOther:
            data.intFeeOther === null ? null : parseInt(data.intFeeOther),
          IntOTFee: data.intOTFee === null ? null : parseInt(data.intOTFee),
          IntFeeNote: data.intFeeNote,
          TransportationFlg: data.transportationFlg,
          TransConfFlg: data.transConfFlg,
          IntConfFlg: data.intConfFlg,
          AppointmentTypeId: data.appointmentTypeId,
          CallerType: data.callerType,
          ProvConfFlg: data.provConfFlg,
          ClmConfFlg: data.clmConfFlg,
          IsDeletedFlg: data.isDeletedFlg,
          BillReviewedFlg: data.billReviewedFlg,
          AuditFlg: data.auditFlg,
          PurpleReportFlg: data.purpleReportFlg,
          RepAuthorizedFlg: data.repAuthorizedFlg,
          SelectedFlg: data.selectedFlg,
          ClmId: data.clmId,
          ClmFirstName: data.clmFirstName,
          ClmLastName: data.clmLastName,
          ClmClaimNumber: data.clmClaimNumber,
          ClmClaimNumberNoDash: data.clmClaimNumberNoDash,
          ClmPhone: data.clmPhone,
          ClmDateOfLoss: data.clmDateOfLoss,
          ClmDateOfInjury: data.clmDateOfInjury,
          ClmDateOfInjuryStart: data.clmDateOfInjuryStart,
          ClmDateOfInjuryEnd: data.clmDateOfInjuryEnd,
          ClmDateOfLossDate: data.clmDateOfLossDate,
          ClmNote: data.clmNote,
          ClmDOB: data.clmDOB,
          ClmInsuredParty: data.clmInsuredParty,
          ClmEmployer: data.clmEmployer,
          ClmInvoiceCaption: data.clmInvoiceCaption,
          ClmLanguage: data.clmLanguage,
          ClmWCABNumber: data.clmWCABNumber,
          ClmInvoiceType: data.clmInvoiceType,
          ClmStreet: data.clmStreet,
          ClmCity: data.clmCity,
          ClmState: data.clmState,
          ClmZip: data.clmZip,
          ClmSSN: data.clmSSN,
          ClmOrderedByName: data.clmOrderedByName,
          ClmDiagnosis: data.clmDiagnosis,
          ClmEmail: data.clmEmail,
          ClmHasAttorneyFlg: data.clmHasAttorneyFlg,
          RepId: data.repId,
          RepFirstName: data.repFirstName,
          RepLastName: data.repLastName,
          RepPhone: data.repPhone,
          RepEmail: data.repEmail,
          ClientId: data.clientId,
          ClientAbbrv: data.clientAbbrv,
          ClientName: data.clientName,
          ClientStreet: data.clientStreet,
          ClientStreet2: data.clientStreet2,
          ClientCity: data.clientCity,
          ClientState: data.clientState,
          ClientZip: data.clientZip,
          ClientMailStreet: data.clientMailStreet,
          ClientMailStreet2: data.clientMailStreet2,
          ClientMailCity: data.clientMailCity,
          ClientMailState: data.clientMailState,
          ClientMailZip: data.clientMailZip,
          ClientPhone: data.clientPhone,
          ClientPhoneFax: data.clientPhoneFax,
          ClientPhone2: data.clientPhone2,
          ClientEmail: data.clientEmail,
          ClientInactiveFlg: data.clientInactiveFlg,
          IntId: data.intId,
          IntLastName: data.intLastName,
          IntFirstName: data.intFirstName,
          IntCellTxt: data.intCellTxt,
          IntPhoneOnly: data.intPhoneOnly,
          IntEmail: data.intEmail,
          IntNote: data.intNote,
          InHouseFlg: data.inHouseFlg,
          IntCity: data.intCity,
          IntStreet: data.intStreet,
          IntState: data.intState,
          IntZip: data.intZip,
          DBA: data.dDBA,
          Rate: data.rate,
          HourMinimum: data.hourMinimum,
          Prorate: data.prorate,
          BankRoute: data.bankRoute,
          BankAccount: data.bankAccount,
          IntSSINumber: data.intSSINumber,
          FirstName: data.firstName,
          LastName: data.lastName,
          UserType: data.userType,
          UserIntId: data.userIntId,
          CreateDateTime: data.createDateTime,
          CreateByUserId: data.createByUserId,
          UpdateDateTime: data.updateDateTime,
          UpdateByUserId: data.updateByUserId,
          RemIntFlg: data.remIntFlg,
          RemClaimFlg: data.remClaimFlg,
          RemProvFlg: data.remProvFlg,
          RemFinalFlg: data.remFinalFlg,
          RemType: data.remType,
          RemTypeDesc: data.remTypeDesc,
          RemHost: data.remHost,
          RemHostDesc: data.remHostDesc,
          CreatedBy: data.createdBy,
          UpdatedBy: data.updatedBy,
          MyJobTJobHistory: data.myJobTJobHistory,
          MyJobWaitingOnCallBack: data.myJobWaitingOnCallBack,
          JobBalance: data.jobBalance,
          WorkFlowId: data.workFlowId,
          JobTypeName: data.jobTypeName,
        },
        selectedIndex: rowIndex,
        //modal: showModal
      }));
    });
  }

  setData(woData, rowIndex, form = "workorder") {
    if (form === "workorder") {
      FetchData(
        "/getworkorder?jobId=" + woData.jobId,
        "POST",
        this.user.token,
        null,
      ).then((data) => {
        this.setState(
          (prevState) => ({
            isFollowup: false,
            followupOriginjobId: null,
            model: {
              EventType: "update",
              JobNum: data.jobNum,
              JobId: data.jobId,
              JobDateTime: data.jobDateTime,
              JobTime: data.jobTime,
              FinishTime: data.finishTime,
              FinishTimeString:
                data.finishTimeString === null ? null : data.finishTimeString,
              FollowupDate: data.followupDate,
              ProvId: data.provId,
              ProviderName: data.providerName,
              ProvEmail: data.provEmail,
              ProvNote: data.provNote,
              IntApptNotes: data.intApptNotes,
              ConfCallNote: data.confCallNote,
              AptName: data.aptName,
              AptStreet: data.aptStreet,
              AptCity: data.aptCity,
              AptState: data.aptState,
              AptZip: data.aptZip,
              AptPhone: data.aptPhone,
              AptDirection: data.aptDirection,
              FailedFlg: data.failedFlg,
              CallerNote: data.callerNote,
              InvoiceNote: data.invoiceNote,
              IntCheckDate: data.intCheckDate,
              IntCheckNum: data.intCheckNum,
              InvoicedFlg: data.invoicedFlg,
              IntFinalConfEmailSentFlg:
                data.IntFinalConfEmailSentFlg ??
                data.intFinalConfEmailSentFlg ??
                data.intFinalConfEmailSendFlg ??
                false,
              JobTotal: data.jobTotal,
              JobDiscount: data.jobDiscount,
              IntFee: data.intFee === null ? null : parseInt(data.intFee),
              IntFeeOther:
                data.intFeeOther === null ? null : parseInt(data.intFeeOther),
              IntOTFee: data.intOTFee === null ? null : parseInt(data.intOTFee),
              IntFeeNote: data.intFeeNote,
              TransportationFlg: data.transportationFlg,
              TransConfFlg: data.transConfFlg,
              IntConfFlg: data.intConfFlg,
              AppointmentTypeId: data.appointmentTypeId,
              CallerType: data.callerType,
              ProvConfFlg: data.provConfFlg,
              ClmConfFlg: data.clmConfFlg,
              IsDeletedFlg: data.isDeletedFlg,
              BillReviewedFlg: data.billReviewedFlg,
              AuditFlg: data.auditFlg,
              PurpleReportFlg: data.purpleReportFlg,
              RepAuthorizedFlg: data.repAuthorizedFlg,
              SelectedFlg: data.selectedFlg,
              ClmId: data.clmId,
              ClmFirstName: data.clmFirstName,
              ClmLastName: data.clmLastName,
              ClmClaimNumber: data.clmClaimNumber,
              ClmClaimNumberNoDash: data.clmClaimNumberNoDash,
              ClmPhone: data.clmPhone,
              ClmDateOfLoss: data.clmDateOfLoss,
              ClmDateOfInjury: data.clmDateOfInjury,
              ClmDateOfInjuryStart: data.clmDateOfInjuryStart,
              ClmDateOfInjuryEnd: data.clmDateOfInjuryEnd,
              ClmDateOfLossDate: data.clmDateOfLossDate,
              ClmNote: data.clmNote,
              ClmDOB: data.clmDOB,
              ClmInsuredParty: data.clmInsuredParty,
              ClmEmployer: data.clmEmployer,
              ClmInvoiceCaption: data.clmInvoiceCaption,
              ClmLanguage: data.clmLanguage,
              ClmWCABNumber: data.clmWCABNumber,
              ClmInvoiceType: data.clmInvoiceType,
              ClmStreet: data.clmStreet,
              ClmCity: data.clmCity,
              ClmState: data.clmState,
              ClmZip: data.clmZip,
              ClmSSN: data.clmSSN,
              ClmOrderedByName: data.clmOrderedByName,
              ClmDiagnosis: data.clmDiagnosis,
              ClmEmail: data.clmEmail,
              ClmHasAttorneyFlg: data.clmHasAttorneyFlg,
              RepId: data.repId,
              RepFirstName: data.repFirstName,
              RepLastName: data.repLastName,
              RepPhone: data.repPhone,
              RepEmail: data.repEmail,
              ClientId: data.clientId,
              ClientAbbrv: data.clientAbbrv,
              ClientName: data.clientName,
              ClientStreet: data.clientStreet,
              ClientStreet2: data.clientStreet2,
              ClientCity: data.clientCity,
              ClientState: data.clientState,
              ClientZip: data.clientZip,
              ClientMailStreet: data.clientMailStreet,
              ClientMailStreet2: data.clientMailStreet2,
              ClientMailCity: data.clientMailCity,
              ClientMailState: data.clientMailState,
              ClientMailZip: data.clientMailZip,
              ClientPhone: data.clientPhone,
              ClientPhoneFax: data.clientPhoneFax,
              ClientPhone2: data.clientPhone2,
              ClientEmail: data.clientEmail,
              ClientInactiveFlg: data.clientInactiveFlg,
              IntId: data.intId,
              IntLastName: data.intLastName,
              IntFirstName: data.intFirstName,
              IntCellTxt: data.intCellTxt,
              IntPhoneOnly: data.intPhoneOnly,
              IntEmail: data.intEmail,
              IntNote: data.intNote,
              InHouseFlg: data.inHouseFlg,
              IntCity: data.intCity,
              IntStreet: data.intStreet,
              IntState: data.intState,
              IntZip: data.intZip,
              DBA: data.dDBA,
              Rate: data.rate,
              HourMinimum: data.hourMinimum,
              Prorate: data.prorate,
              BankRoute: data.bankRoute,
              BankAccount: data.bankAccount,
              IntSSINumber: data.intSSINumber,
              FirstName: data.firstName,
              LastName: data.lastName,
              UserType: data.userType,
              UserIntId: data.userIntId,
              CreateDateTime: data.createDateTime,
              CreateByUserId: data.createByUserId,
              UpdateDateTime: data.updateDateTime,
              UpdateByUserId: data.updateByUserId,
              RemIntFlg: data.remIntFlg,
              RemClaimFlg: data.remClaimFlg,
              RemProvFlg: data.remProvFlg,
              RemFinalFlg: data.remFinalFlg,
              RemType: data.remType,
              RemTypeDesc: data.remTypeDesc,
              RemHost: data.remHost,
              RemHostDesc: data.remHostDesc,
              CreatedBy: data.createdBy,
              UpdatedBy: data.updatedBy,
              MyJobTJobHistory: data.myJobTJobHistory,
              MyJobWaitingOnCallBack: data.myJobWaitingOnCallBack,
              JobBalance: data.jobBalance,
              WorkFlowId: data.workFlowId,
              JobTypeName: data.jobTypeName,
            },
            selectedIndex: rowIndex,
            //modal: showModal
          }),
          () => {
            this.setModal();
          },
        );
      });
    } else {
      this.setState(
        (prevState) => ({
          isFollowup: false,
          followupOriginjobId: null,
          model: {
            EventType: "update",
            JobNum: woData.jobNum,
            JobId: woData.jobId,
            JobDateTime: woData.jobDateTime,
            JobTime: woData.jobTime,
            FinishTime: woData.finishTime,
            FinishTimeString:
              woData.finishTimeString === null ? null : woData.finishTimeString,
            FollowupDate: woData.followupDate,
            ProvId: woData.provId,
            ProviderName: woData.providerName,
            ConfCallNote: woData.confCallNote,
            AptName: woData.aptName,
            AptStreet: woData.aptStreet,
            AptCity: woData.aptCity,
            AptState: woData.aptState,
            AptZip: woData.aptZip,
            AptPhone: woData.aptPhone,
            AptDirection: woData.aptDirection,
            FailedFlg: woData.failedFlg,
            CallerNote: woData.callerNote,
            InvoiceNote: woData.invoiceNote,
            IntCheckDate: woData.intCheckDate,
            IntCheckNum: woData.intCheckNum,
            InvoicedFlg: woData.invoicedFlg,
            IntFinalConfEmailSentFlg:
              woData.IntFinalConfEmailSentFlg ??
              woData.intFinalConfEmailSentFlg ??
              woData.intFinalConfEmailSendFlg ??
              false,
            JobTotal: woData.jobTotal,
            JobDiscount: woData.jobDiscount,
            IntFee:
              woData.intFee === null
                ? null
                : parseFloat(woData.intFee).toFixed(2),
            IntFeeOther:
              woData.intFeeOther === null
                ? null
                : parseFloat(woData.intFeeOther).toFixed(2),
            IntOTFee:
              woData.intOTFee === null
                ? null
                : parseFloat(woData.intOTFee).toFixed(2),
            IntFeeNote: woData.intFeeNote,
            TransportationFlg: woData.transportationFlg,
            TransConfFlg: woData.transConfFlg,
            IntConfFlg: woData.intConfFlg,
            AppointmentTypeId: woData.appointmentTypeId,
            CallerType: woData.callerType,
            ProvConfFlg: woData.provConfFlg,
            ClmConfFlg: woData.clmConfFlg,
            IsDeletedFlg: woData.isDeletedFlg,
            BillReviewedFlg: woData.billReviewedFlg,
            AuditFlg: woData.auditFlg,
            PurpleReportFlg: woData.purpleReportFlg,
            RepAuthorizedFlg: woData.repAuthorizedFlg,
            SelectedFlg: woData.selectedFlg,
            ClmId: woData.clmId,
            ClmFirstName: woData.clmFirstName,
            ClmLastName: woData.clmLastName,
            ClmClaimNumber: woData.clmClaimNumber,
            ClmClaimNumberNoDash: woData.clmClaimNumberNoDash,
            ClmPhone: woData.clmPhone,
            ClmDateOfLoss: woData.clmDateOfLoss,
            ClmDateOfInjury: woData.clmDateOfInjury,
            ClmDateOfInjuryStart: woData.clmDateOfInjuryStart,
            ClmDateOfInjuryEnd: woData.clmDateOfInjuryEnd,
            ClmDateOfLossDate: woData.clmDateOfLossDate,
            ClmNote: woData.clmNote,
            ClmDOB: woData.clmDOB,
            ClmInsuredParty: woData.clmInsuredParty,
            ClmEmployer: woData.clmEmployer,
            ClmInvoiceCaption: woData.clmInvoiceCaption,
            ClmLanguage: woData.clmLanguage,
            ClmWCABNumber: woData.clmWCABNumber,
            ClmInvoiceType: woData.clmInvoiceType,
            ClmStreet: woData.clmStreet,
            ClmCity: woData.clmCity,
            ClmState: woData.clmState,
            ClmZip: woData.clmZip,
            ClmSSN: woData.clmSSN,
            ClmOrderedByName: woData.clmOrderedByName,
            ClmDiagnosis: woData.clmDiagnosis,
            ClmEmail: woData.clmEmail,
            ClmHasAttorneyFlg: woData.clmHasAttorneyFlg,
            RepId: woData.repId,
            RepFirstName: woData.repFirstName,
            RepLastName: woData.repLastName,
            RepPhone: woData.repPhone,
            RepEmail: woData.repEmail,
            ClientId: woData.clientId,
            ClientAbbrv: woData.clientAbbrv,
            ClientName: woData.clientName,
            ClientStreet: woData.clientStreet,
            ClientStreet2: woData.clientStreet2,
            ClientCity: woData.clientCity,
            ClientState: woData.clientState,
            ClientZip: woData.clientZip,
            ClientMailStreet: woData.clientMailStreet,
            ClientMailStreet2: woData.clientMailStreet2,
            ClientMailCity: woData.clientMailCity,
            ClientMailState: woData.clientMailState,
            ClientMailZip: woData.clientMailZip,
            ClientPhone: woData.clientPhone,
            ClientPhoneFax: woData.clientPhoneFax,
            ClientPhone2: woData.clientPhone2,
            ClientEmail: woData.clientEmail,
            ClientInactiveFlg: woData.clientInactiveFlg,
            IntId: woData.intId,
            IntLastName: woData.intLastName,
            IntFirstName: woData.intFirstName,
            IntCellTxt: woData.intCellTxt,
            IntPhoneOnly: woData.intPhoneOnly,
            IntEmail: woData.intEmail,
            IntNote: woData.intNote,
            InHouseFlg: woData.inHouseFlg,
            IntCity: woData.intCity,
            IntStreet: woData.intStreet,
            IntState: woData.intState,
            IntZip: woData.intZip,
            DBA: woData.dDBA,
            Rate: woData.rate,
            HourMinimum: woData.hourMinimum,
            Prorate: woData.prorate,
            BankRoute: woData.bankRoute,
            BankAccount: woData.bankAccount,
            IntSSINumber: woData.intSSINumber,
            FirstName: woData.firstName,
            LastName: woData.lastName,
            UserType: woData.userType,
            UserIntId: woData.userIntId,
            CreateDateTime: woData.createDateTime,
            CreateByUserId: woData.createByUserId,
            UpdateDateTime: woData.updateDateTime,
            UpdateByUserId: woData.updateByUserId,
            RemIntFlg: woData.remIntFlg,
            RemClaimFlg: woData.remClaimFlg,
            RemProvFlg: woData.remProvFlg,
            RemFinalFlg: woData.remFinalFlg,
            RemType: woData.remType,
            RemTypeDesc: woData.remTypeDesc,
            RemHost: woData.remHost,
            RemHostDesc: woData.remHostDesc,
            CreatedBy: woData.createdBy,
            UpdatedBy: woData.updatedBy,
            MyJobTJobHistory: woData.myJobTJobHistory,
            JobBalance: woData.jobBalance,
            WorkFlowId: woData.workFlowId,
            JobTypeName: woData.jobTypeName,
          },
          selectedIndex: rowIndex,
        }),
        () => {
          this.setModal();
        },
      );
    }
  }

  handleWorkOrderModelChange(updatedModel) {
    if (!updatedModel) {
      return;
    }

    this.setState({
      model: { ...updatedModel },
    });
  }

  refreshWorkOrderData(jobId) {
    FetchData(
      "/getworkorder?jobId=" + jobId,
      "POST",
      this.user.token,
      null,
    ).then((data) => {
      this.setState((prevState) => ({
        model: {
          EventType: "update",
          JobNum: data.jobNum,
          JobId: data.jobId,
          JobDateTime: data.jobDateTime,
          JobTime: data.jobTime,
          FinishTime: data.finishTime,
          FinishTimeString:
            data.finishTimeString === null ? null : data.finishTimeString,
          FollowupDate: data.followupDate,
          ProvId: data.provId,
          ProviderName: data.providerName,
          ConfCallNote: data.confCallNote,
          AptName: data.aptName,
          AptStreet: data.aptStreet,
          AptCity: data.aptCity,
          AptState: data.aptState,
          AptZip: data.aptZip,
          AptPhone: data.aptPhone,
          AptDirection: data.aptDirection,
          FailedFlg: data.failedFlg,
          CallerNote: data.callerNote,
          InvoiceNote: data.invoiceNote,
          IntCheckDate: data.intCheckDate,
          IntCheckNum: data.intCheckNum,
          InvoicedFlg: data.invoicedFlg,
          IntFinalConfEmailSentFlg: data.IntFinalConfEmailSentFlg,
          JobTotal: data.jobTotal,
          JobDiscount: data.jobDiscount,
          IntFee: data.intFee === null ? null : parseInt(data.intFee),
          IntFeeOther:
            data.intFeeOther === null ? null : parseInt(data.intFeeOther),
          IntOTFee: data.intOTFee === null ? null : parseInt(data.intOTFee),
          IntFeeNote: data.intFeeNote,
          TransportationFlg: data.transportationFlg,
          TransConfFlg: data.transConfFlg,
          IntConfFlg: data.intConfFlg,
          AppointmentTypeId: data.appointmentTypeId,
          CallerType: data.callerType,
          ProvConfFlg: data.provConfFlg,
          ClmConfFlg: data.clmConfFlg,
          IsDeletedFlg: data.isDeletedFlg,
          BillReviewedFlg: data.billReviewedFlg,
          AuditFlg: data.auditFlg,
          PurpleReportFlg: data.purpleReportFlg,
          RepAuthorizedFlg: data.repAuthorizedFlg,
          SelectedFlg: data.selectedFlg,
          ClmId: data.clmId,
          ClmFirstName: data.clmFirstName,
          ClmLastName: data.clmLastName,
          ClmClaimNumber: data.clmClaimNumber,
          ClmClaimNumberNoDash: data.clmClaimNumberNoDash,
          ClmPhone: data.clmPhone,
          ClmDateOfLoss: data.clmDateOfLoss,
          ClmDateOfInjury: data.clmDateOfInjury,
          ClmDateOfInjuryStart: data.clmDateOfInjuryStart,
          ClmDateOfInjuryEnd: data.clmDateOfInjuryEnd,
          ClmDateOfLossDate: data.clmDateOfLossDate,
          ClmNote: data.clmNote,
          ClmDOB: data.clmDOB,
          ClmInsuredParty: data.clmInsuredParty,
          ClmEmployer: data.clmEmployer,
          ClmInvoiceCaption: data.clmInvoiceCaption,
          ClmLanguage: data.clmLanguage,
          ClmWCABNumber: data.clmWCABNumber,
          ClmInvoiceType: data.clmInvoiceType,
          ClmStreet: data.clmStreet,
          ClmCity: data.clmCity,
          ClmState: data.clmState,
          ClmZip: data.clmZip,
          ClmSSN: data.clmSSN,
          ClmOrderedByName: data.clmOrderedByName,
          ClmDiagnosis: data.clmDiagnosis,
          ClmEmail: data.clmEmail,
          ClmHasAttorneyFlg: data.clmHasAttorneyFlg,
          RepId: data.repId,
          RepFirstName: data.repFirstName,
          RepLastName: data.repLastName,
          RepPhone: data.repPhone,
          RepEmail: data.repEmail,
          ClientId: data.clientId,
          ClientAbbrv: data.clientAbbrv,
          ClientName: data.clientName,
          ClientStreet: data.clientStreet,
          ClientStreet2: data.clientStreet2,
          ClientCity: data.clientCity,
          ClientState: data.clientState,
          ClientZip: data.clientZip,
          ClientMailStreet: data.clientMailStreet,
          ClientMailStreet2: data.clientMailStreet2,
          ClientMailCity: data.clientMailCity,
          ClientMailState: data.clientMailState,
          ClientMailZip: data.clientMailZip,
          ClientPhone: data.clientPhone,
          ClientPhoneFax: data.clientPhoneFax,
          ClientPhone2: data.clientPhone2,
          ClientEmail: data.clientEmail,
          ClientInactiveFlg: data.clientInactiveFlg,
          IntId: data.intId,
          IntLastName: data.intLastName,
          IntFirstName: data.intFirstName,
          IntCellTxt: data.intCellTxt,
          IntPhoneOnly: data.intPhoneOnly,
          IntEmail: data.intEmail,
          IntNote: data.intNote,
          InHouseFlg: data.inHouseFlg,
          IntCity: data.intCity,
          IntStreet: data.intStreet,
          IntState: data.intState,
          IntZip: data.intZip,
          DBA: data.dDBA,
          Rate: data.rate,
          HourMinimum: data.hourMinimum,
          Prorate: data.prorate,
          BankRoute: data.bankRoute,
          BankAccount: data.bankAccount,
          IntSSINumber: data.intSSINumber,
          FirstName: data.firstName,
          LastName: data.lastName,
          UserType: data.userType,
          UserIntId: data.userIntId,
          CreateDateTime: data.createDateTime,
          CreateByUserId: data.createByUserId,
          UpdateDateTime: data.updateDateTime,
          UpdateByUserId: data.updateByUserId,
          RemIntFlg: data.remIntFlg,
          RemClaimFlg: data.remClaimFlg,
          RemProvFlg: data.remProvFlg,
          RemFinalFlg: data.remFinalFlg,
          RemType: data.remType,
          RemTypeDesc: data.remTypeDesc,
          RemHost: data.remHost,
          RemHostDesc: data.remHostDesc,
          CreatedBy: data.createdBy,
          UpdatedBy: data.updatedBy,
          MyJobTJobHistory: data.myJobTJobHistory,
          MyJobWaitingOnCallBack: data.myJobWaitingOnCallBack,
          JobBalance: data.jobBalance,
          WorkFlowId: data.workFlowId,
          JobTypeName: data.jobTypeName,
        },
      }));
      this.getJobHistory(data.jobId);
      this.getJobInvLine(data.jobId);
    });
  }

  setJobData(woData) {
    this.setState((prevState) => {
      const updates = { selectedJob: woData };
      // If the current model relates to this job, also update JobTypeName so dependent components (e.g., print preview) see it.
      if (prevState.model && prevState.model.JobId === woData.jobId) {
        updates.model = { ...prevState.model, JobTypeName: woData.jobTypeName };
      }
      return updates;
    });
  }

  addSchedule(woData, rowIndex) {
    let currentDate = new Date();
    let currentMonth = currentDate.getMonth() + 1;
    const time = currentDate.toLocaleTimeString();
    let callerNote =
      "Scheduled From Calendar " +
      currentMonth +
      "/" +
      currentDate.getDate() +
      "/" +
      currentDate.getFullYear() +
      " " +
      time +
      " By: " +
      this.user.firstname +
      " " +
      this.user.lastname;

    this.setState((prevState) => ({
      isFollowup: true,
      followupOriginjobId: woData.jobId,
      model: {
        EventType: "insert",
        JobNum: 0,
        JobId: null,
        JobDateTime: null,
        JobTime: null,
        FinishTime: null,
        FinishTimeString: null,
        FollowupDate: null,
        ProvId: woData.provId,
        ProviderName: woData.providerName,
        ConfCallNote: woData.confCallNote,
        AptName: woData.aptName,
        AptStreet: woData.aptStreet,
        AptCity: woData.aptCity,
        AptState: woData.aptState,
        AptZip: woData.aptZip,
        AptPhone: woData.aptPhone,
        AptDirection: woData.aptDirection,
        FailedFlg: woData.failedFlg,
        CallerNote: callerNote,
        InvoiceNote: "", //woData.invoiceNote,
        IntCheckDate: null, //woData.intCheckDate,
        IntCheckNum: null, //woData.intCheckNum,
        InvoicedFlg: false,
        JobTotal: 0, //woData.jobTotal,
        JobDiscount: woData.jobDiscount,
        IntFee: null,
        IntFeeOther: null,
        TransportationFlg: woData.transportationFlg,
        TransConfFlg: woData.transConfFlg,
        IntConfFlg: false,
        IntFinalConfEmailSentFlg: false,
        AppointmentTypeId: woData.appointmentTypeId,
        CallerType: null,
        ProvConfFlg: false,
        ClmConfFlg: true,
        IsDeletedFlg: woData.isDeletedFlg,
        BillReviewedFlg: false, //woData.billReviewedFlg,
        AuditFlg: false,
        PurpleReportFlg: false,
        RepAuthorizedFlg: false,
        SelectedFlg: woData.selectedFlg,
        ClmId: woData.clmId,
        ClmFirstName: woData.clmFirstName,
        ClmLastName: woData.clmLastName,
        ClmClaimNumber: woData.clmClaimNumber,
        ClmClaimNumberNoDash: woData.clmClaimNumberNoDash,
        ClmPhone: woData.clmPhone,
        ClmDateOfLoss: woData.clmDateOfLoss,
        ClmDateOfInjury: woData.clmDateOfInjury,
        ClmDateOfInjuryStart: woData.clmDateOfInjuryStart,
        ClmDateOfInjuryEnd: woData.clmDateOfInjuryEnd,
        ClmDateOfLossDate: woData.clmDateOfLossDate,
        ClmNote: woData.clmNote,
        ClmDOB: woData.clmDOB,
        ClmInsuredParty: woData.clmInsuredParty,
        ClmEmployer: woData.clmEmployer,
        ClmInvoiceCaption: woData.clmInvoiceCaption,
        ClmLanguage: woData.clmLanguage,
        ClmWCABNumber: woData.clmWCABNumber,
        ClmInvoiceType: woData.clmInvoiceType,
        ClmStreet: woData.clmStreet,
        ClmCity: woData.clmCity,
        ClmState: woData.clmState,
        ClmZip: woData.clmZip,
        ClmSSN: woData.clmSSN,
        ClmOrderedByName: woData.clmOrderedByName,
        ClmDiagnosis: woData.clmDiagnosis,
        ClmEmail: woData.clmEmail,
        ClmHasAttorneyFlg: woData.clmHasAttorneyFlg,
        RepId: woData.repId,
        RepFirstName: woData.repFirstName,
        RepLastName: woData.repLastName,
        RepPhone: woData.repPhone,
        RepEmail: woData.repEmail,
        ClientId: woData.clientId,
        ClientAbbrv: woData.clientAbbrv,
        ClientName: woData.clientName,
        ClientStreet: woData.clientStreet,
        ClientStreet2: woData.clientStreet2,
        ClientCity: woData.clientCity,
        ClientState: woData.clientState,
        ClientZip: woData.clientZip,
        ClientMailStreet: woData.clientMailStreet,
        ClientMailStreet2: woData.clientMailStreet2,
        ClientMailCity: woData.clientMailCity,
        ClientMailState: woData.clientMailState,
        ClientMailZip: woData.clientMailZip,
        ClientPhone: woData.clientPhone,
        ClientPhoneFax: woData.clientPhoneFax,
        ClientPhone2: woData.clientPhone2,
        ClientEmail: woData.clientEmail,
        ClientInactiveFlg: woData.clientInactiveFlg,
        IntId: woData.intId,
        IntLastName: woData.intLastName,
        IntFirstName: woData.intFirstName,
        IntCellTxt: woData.IntCellTxt,
        IntPhoneOnly: woData.IntPhoneOnly,
        IntEmail: woData.intEmail,
        IntNote: woData.intNote,
        InHouseFlg: woData.inHouseFlg,
        IntCity: woData.intCity,
        IntStreet: woData.intStreet,
        IntState: woData.intState,
        IntZip: woData.intZip,
        DBA: woData.dDBA,
        Rate: woData.rate,
        HourMinimum: woData.hourMinimum,
        Prorate: woData.prorate,
        BankRoute: woData.bankRoute,
        BankAccount: woData.bankAccount,
        IntSSINumber: woData.intSSINumber,
        FirstName: woData.firstName,
        LastName: woData.lastName,
        UserType: woData.userType,
        UserIntId: woData.userIntId,
        CreateDateTime: woData.createDateTime,
        CreateByUserId: woData.createByUserId,
        UpdateDateTime: woData.updateDateTime,
        UpdateByUserId: woData.updateByUserId,
        RemIntFlg: false,
        RemClaimFlg: false,
        RemProvFlg: false,
        RemFinalFlg: false, //woData.remFinalFlg,
        RemType: null, //woData.remType,
        RemTypeDesc: woData.remTypeDesc,
        RemHost: null, //woData.remHost,
        RemHostDesc: woData.remHostDesc,
        CreatedBy: woData.createdBy,
        UpdatedBy: woData.updatedBy,
        JobTypeName: woData.jobTypeName,
      },
      selectedIndex: rowIndex,
      jobHistoryList: [],
      jobInvLineList: [],
    }));
  }

  setInterpreterEmail(woData) {
    var checkMailedOn = "";
    var d = new Date(woData.jobDateTime);
    var newD;
    if (d.getDate() <= 15) {
      newD = new Date(d.getMonth() + 1 + "/15/" + d.getFullYear());
    } else {
      newD = moment(d).add(1, "M").toDate();
      newD = new Date(newD.getMonth() + 1 + "/1/" + newD.getFullYear());
    }

    switch (newD.getDay()) {
      case 4:
        newD = moment(newD).add(5, "d").toDate();
        break;
      case 5:
        newD = moment(newD).add(4, "d").toDate();
        break;
      case 6:
        newD = moment(newD).add(3, "d").toDate();
        break;
      default:
        newD = moment(newD).add(2, "d").toDate();
    }

    checkMailedOn = moment(newD).format("MM/DD/YYYY");
    var checkMailedOnDate = new Date(checkMailedOn);

    var body = "Dear " + woData.intFirstName + ",";
    body +=
      "\n\n---\nFor privacy reasons, we have replaced the claimant's name with their claim number in this communication. The claimant's full name can be viewed inside the portal.";
    body +=
      "\n\nPlease ** REPLY TO THIS EMAIL ** to confirm this is in your book:";
    body += "\n\nJob: " + woData.jobNum;
    body += "\nFor: Claim #" + woData.clmClaimNumber;
    body +=
      "\nOn: " +
      moment(woData.jobDateTime).format("MM/DD/YYYY") +
      " (" +
      this.state.dayNames[moment(woData.jobDateTime).day()] +
      ") " +
      " at " +
      moment(woData.jobDateTime).format("hh:mm A");

    body += "\nAt: " + (woData.providerName || "");

    if (woData.aptStreet) {
      body += `\n    ${woData.aptStreet}`;
    }

    if (woData.aptCity || woData.aptState || woData.aptZip) {
      body += `\n    ${[woData.aptCity, woData.aptState, woData.aptZip]
        .filter(Boolean)
        .join(", ")}`;
    }

    body +=
      "\n\nIf there is any problem or if the patient does not appear within 15 mins of start time, please CALL US right away. If you are not required to interpret, you MUST call us BEFORE leaving the appointment.";

    if (
      woData.rate != null &&
      woData.hourMinimum != null &&
      woData.prorate !== ""
    ) {
      body += "\n\nWe have your rate as $" + woData.rate + " an hour, ";
      body += "with a " + woData.hourMinimum + " hour minimum, ";
      body += "additional time paid in " + woData.prorate + " increments. ";
    }
    body +=
      "Your payment will be deposited into your account by " +
      this.state.monthNames[checkMailedOnDate.getMonth()] +
      " " +
      checkMailedOnDate.getDate() +
      ", " +
      checkMailedOnDate.getFullYear() +
      ". ";
    body += `\nPlease refer to <a href='${PORTAL_URL}' target="_blank">${PORTAL_URL}</a> for any other questions.`;

    body += `\n\nTo access our Portal and FAQ click at <a href='${PORTAL_URL}' target="_blank">${PORTAL_URL}</a>`;

    body += "\n\nThank you,";
    body += "\n\n" + this.user.firstname + " " + this.user.lastname;

    body +=
      "\n\nExecutive Linguist Agency \n800-522-2320 | Text: 310-955-4513 | 8am - 5pm Nationwide \nQuestions: mail@executivelinguist.com";

    this.setState((prevState) => ({
      selectedJob: woData,
      showButtons: "cancellation,remote_email,covering_email",
      email: {
        EmailFrom: this.user.email,
        EmailTo: woData.intEmail,
        EmailCC: "",
        Subject: "Interpreting Assignment",
        Body: body,
        JobIds: woData.jobId.toString(),
        CreatedByUserId: this.user.userid,
      },
    }));
    this.setModalIntFormEmail();
  }

  openInterpreter(intId) {
    FetchData("/getinterpreters", "POST", this.user.token, {
      IntId: intId,
      ShowAll: true,
    }).then((data) => {
      this.setState(
        (prevState) => ({
          interpreter: {
            EventType: "update",
            IntId: data[0].intId,
            IntLastName: data[0].intLastName,
            IntFirstName: data[0].intFirstName,
            IntGender: data[0].intGender,
            IntPronoun: data[0].intPronoun,
            IntEmail: data[0].intEmail,
            IntCellTxt: data[0].intCellTxt,
            IntPhoneOnly: data[0].intPhoneOnly,
            IntFax: data[0].intFax,
            IntBeeper: data[0].intBeeper,
            IntStreet: data[0].intStreet,
            IntCity: data[0].intCity,
            IntState: data[0].intState,
            IntZip: data[0].intZip,
            IntCountry: data[0].intCountry,
            IntSSINumber: data[0].intSSINumber,
            IntActiveFlg: data[0].intActiveFlg,
            IntCorporationFlg: data[0].intCorporationFlg,
            DBA: data[0].dBA,
            InHouseFlg: data[0].inHouseFlg,
            UnVettedFlg: data[0].unVettedFlg,
            EmergencyContact: data[0].emergencyContact,
            UnavailableReason: data[0].unavailableReason,
            BankName: data[0].bankName,
            BankAccount: data[0].bankAccount,
            BankRoute: data[0].bankRoute,
            Rate: data[0].rate,
            HourMinimum: data[0].hourMinimum,
            Prorate: data[0].prorate,
            ConfCallRate: data[0].confCallRate,
            BusinessCardRequestDate: data[0].businessCardRequestDate,
            BusinessCardRequestToProcessFlg:
              data[0].businessCardRequestToProcessFlg,
            IntNote: data[0].intNote,
            ReferredBy: data[0].referredBy,
            CreateDateTime: data[0].createDateTime,
            CreateByUserId: data[0].createByUserId,
            UpdateByUserId: data[0].updateByUserId,
            UpdateDateTime: data[0].updateDateTime,
            IsDeletedFlg: data[0].isDeletedFlg,
            CreatedBy: data[0].createdBy,
            UpdatedBy: data[0].updatedBy,
          },
        }),
        () => {
          this.setModalInterpreter();
        },
      );
    });
  }

  setRepEmail(woData) {
    this.setState(
      (prevState) => ({
        selectedJob: woData,
        email: {
          EmailFrom: this.user.email,
          EmailTo: woData.repEmail,
          EmailCC: "mail@executivelinguist.com",
          Subject: buildAuthEmailSubject(woData),
          Body: buildRepIconEmailBody(woData, `${this.user.firstname} ${this.user.lastname}`),
          JobIds: woData.jobId.toString(),
          JobNums: woData.jobNum.toString(),
          EmailType: "email1",
          EmailSource: "repEmail",
          CreatedByUserId: this.user.userid,
        },
      }),
      () => {
        this.setModalRepFormEmail();
      },
    );
  }

  async setRepEmail2(woData) {
    const clientData = await FetchData("/getclients", "POST", this.user.token, {
      ClientId: woData.clientId,
    });

    this.setState({ clientForEmail: clientData, fetchingData: false });
    const client = Array.isArray(clientData) ? clientData[0] : null;

    let emailAddress = woData.repEmail;
    if (client && client.clientEmailForInvoice) {
      if (client.clientEmailForInvoice.includes("@")) {
        emailAddress = client.clientEmailForInvoice;
      }
    }

    var d = new Date(woData.jobDateTime);
    var newD;
    if (d.getDate() <= 15) {
      newD = new Date(d.getMonth() + 1 + "/15/" + d.getFullYear());
    } else {
      newD = moment(d).add(1, "M").toDate();
      newD = new Date(newD.getMonth() + 1 + "/1/" + newD.getFullYear());
    }

    switch (newD.getDay()) {
      case 4:
        newD = moment(newD).add(5, "d").toDate();
        break;
      case 5:
        newD = moment(newD).add(4, "d").toDate();
        break;
      case 6:
        newD = moment(newD).add(3, "d").toDate();
        break;
      default:
        newD = moment(newD).add(2, "d").toDate();
    }

    var subject =
      woData.clmFirstName +
      " " +
      woData.clmLastName +
      " CLM # " +
      woData.clmClaimNumber;
    subject += " - " + moment(woData.jobDateTime).format("MM/DD/YYYY");

    var body = "Dear " + woData.repFirstName + ",";
    body +=
      "\n\nPlease remit payment at your earliest convenience. Feel free to contact us at (800) 522-2320 if you have questions.";

    body += "\n\n\nThank you,";
    body += "\n\n" + this.user.firstname + " " + this.user.lastname;

    body +=
      "\n\nExecutive Linguist Agency \n800-522-2320 | 310-376-1409 | 8am - 5pm Nationwide \nDiversified Language Services – Translation & Localization \nVideo Remote, Telephonic, and On - site Interpreting \nrequests: mail@executivelinguist.com";

    this.setState((prevState) => ({
      selectedJob: woData,
      email: {
        EmailFrom: this.user.email,
        EmailTo: emailAddress,
        EmailCC: "",
        Subject: subject,
        Body: body,
        JobNums: woData.jobNum.toString(),
        JobIds: woData.jobId.toString(),
        EmailType: "email2",
        EmailSource: "repEmailWithInvoice",
        CreatedByUserId: this.user.userid,
      },
    }));
    this.setModalRepFormEmail();
  }

  setProviderEmail(woData) {
    var d = new Date(woData.jobDateTime);
    var newD;
    if (d.getDate() <= 15) {
      newD = new Date(d.getMonth() + 1 + "/15/" + d.getFullYear());
    } else {
      newD = moment(d).add(1, "M").toDate();
      newD = new Date(newD.getMonth() + 1 + "/1/" + newD.getFullYear());
    }

    switch (newD.getDay()) {
      case 4:
        newD = moment(newD).add(5, "d").toDate();
        break;
      case 5:
        newD = moment(newD).add(4, "d").toDate();
        break;
      case 6:
        newD = moment(newD).add(3, "d").toDate();
        break;
      default:
        newD = moment(newD).add(2, "d").toDate();
    }

    var subject =
      "Confirmation Request for " +
      moment(woData.jobDateTime).format("MM/DD/YYYY") +
      ", " +
      woData.clmFirstName +
      " " +
      woData.clmLastName;

    var body = "Good day,";
    body +=
      "\n\nIn order to provide interpreting services, we need to confirm that the information is correct for this appointment:";
    body += "\n\nJob: " + woData.jobNum;
    body +=
      "\nFor: " +
      woData.clmFirstName +
      " " +
      woData.clmLastName +
      ", " +
      moment(woData.clmDOB).format("MM/DD/YY") +
      ", " +
      woData.clmClaimNumber;
    body +=
      "\nOn: " +
      moment(woData.jobDateTime).format("MM/DD/YYYY") +
      " (" +
      this.state.dayNames[moment(woData.jobDateTime).day()] +
      ") " +
      " at " +
      moment(woData.jobDateTime).format("hh:mm A");
    const safeValue = (value) =>
      value === null || value === undefined ? "" : value;
    body += "\nAt: " + safeValue(woData.providerName);
    body += "\n    " + safeValue(woData.aptStreet);
    body +=
      "\n    " +
      safeValue(woData.aptCity) +
      ", " +
      safeValue(woData.aptState) +
      " " +
      safeValue(woData.aptZip);
    body += "\nExpected Duration: ";

    body +=
      "\n\n<b>Please let us know if everything is correct or if we need to make any changes.</b> ";
    body += "\n\nThank you!";

    this.setState(
      (prevState) => ({
        selectedJob: woData,
        email: {
          EmailFrom: this.user.email,
          EmailTo: woData.provEmail,
          EmailCC: "",
          Subject: subject,
          Body: body,
          JobIds: woData.jobId.toString(),
          EmailType: "email1",
          CreatedByUserId: this.user.userid,
        },
      }),
      () => {
        this.setModalProviderFormEmail();
      },
    );
  }

  setNextPrevData(rowIndex) {
    if (this.state.selectedIndex + rowIndex < 0) {
      this.setState(
        {
          selectedIndex: 0,
        },
        () => {},
      );
    } else if (
      this.state.selectedIndex + rowIndex >
      this.state.workOrderList.length
    ) {
      this.setState(
        {
          selectedIndex: this.state.workOrderList.length,
        },
        () => {},
      );
    } else {
      this.setState(
        {
          selectedIndex: this.state.selectedIndex + rowIndex,
        },
        () => {},
      );
    }
  }

  getJobHistory(jobId) {
    let model = {
      JobId: jobId,
    };

    FetchData("/getjobhistory", "POST", this.user.token, model).then((data) => {
      this.setState({
        jobHistoryList: Array.isArray(data) ? data : [],
        fetchingData: false,
      });
    });
  }

  getJobInvLine(jobId) {
    let model = {
      JobId: jobId,
    };
    FetchData("/getjobinvline", "POST", this.user.token, model).then((data) => {
      this.setState({ jobInvLineList: data, fetchingData: false });
    });
  }

  getClientForRepEmail(clientId) {
    let searchModel = {
      ClientId: clientId,
    };

    FetchData("/getclients", "POST", this.user.token, searchModel).then(
      (data) => {
        this.setState((prevState) => ({
          client: {
            EventType: "update",
            ClientId: null,
            ClientAbbrv: data.clientAbbrv,
            ClientPhone: data.clientPhone,
            ClientPhone2: data.clientPhone2,
            ClientPhoneFax: data.clientPhoneFax,
            ClientName: data.clientName,
            ClientMailStreet: data.clientMailStreet,
            ClientMailStreet2: data.clientMailStreet2,
            ClientMailCity: data.clientMailCity,
            ClientMailState: data.clientMailState,
            ClientMailZip: data.clientMailZip,
            ClientStreet: data.clientStreet,
            ClientStreet2: data.clientStreet2,
            ClientCity: data.clientCity,
            ClientState: data.clientState,
            ClientZip: data.clientZip,
            ClientCountry: data.clientCountry,
            ClientDiscount: data.clientDiscount,
            ClientNotes: data.clientNotes,
            ClientCreditCard: data.clientCreditCard,
            ClientEmailForInvoice: data.clientEmailForInvoice,
            ClientEmail: data.clientEmail,
            ClientWebsite: data.clientWebsite,
            ClientOrg: data.clientOrd,
            ClientBillRateType: data.clientBillRateType,
            ClientInactiveFlg: data.clientInactiveFlg,
            CreateDateTime: data.createDateTime,
            CreateByUserId: data.CreateByUserId,
            UpdateByUserId: data.UpdateByUserId,
            UpdateDateTime: data.UpdateDateTime,
            IsDeletedFlg: false,
          },
        }));
      },
    );
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        fetchingData: false,
        selectedJob: null,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState((prevState) => ({
            alert: {
              ...prevState.alert,
              isOpen: false,
            },
          }));
        }, Timeout(alert.message));

        if (
          this.state.tableView !== "deletedjobs" &&
          this.state.tableView !== "purplereport" &&
          this.state.tableView !== "pending" &&
          this.state.tableView !== "callback"
        ) {
          this.populateWorkOrderData();
        } else if (this.state.tableView === "callback") {
          this.populateWorkOrderCallbackData();
        } else if (this.state.tableView === "deletedjobs") {
          this.populateDeletedJobsData();
        } else if (this.state.tableView === "purplereport") {
          this.populateWorkOrderPurpleReportData();
        } else if (this.state.tableView === "pending") {
          this.populateWorkOrderPendingData();
        } else if (this.state.tableView === "finalconf") {
          this.populateWorkOrderFinalConfirmationData();
        }
      },
    );
  }

  handleSaveEventIntEmailSuccess(alert) {
    this.setState(
      {
        modalIntFormEmail: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
        this.unCheckAll();
      },
    );
  }

  handleSaveEventRepEmailSuccess(alert) {
    this.setState(
      {
        modalRepFormEmail: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
        this.unCheckAll();
      },
    );
  }

  handleSaveEventProviderEmailSuccess(alert) {
    this.setState(
      {
        modalProviderFormEmail: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState((prevState) => ({
            alert: { ...prevState.alert, isOpen: false },
          }));
        }, Timeout(alert.message));
        this.unCheckAll();
      },
    );
  }

  handleSaveEventInterpreterSuccess(alert) {
    this.setState(
      {
        modalInterpreter: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState((prevState) => ({
            alert: { ...prevState.alert, isOpen: false },
          }));
        }, Timeout(alert.message));
      },
    );
  }

  handleSaveEventEmailConfirmSuccess(alert) {
    this.setState(
      {
        modalEmailConfirm: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState((prevState) => ({
            alert: { ...prevState.alert, isOpen: false },
          }));
        }, Timeout(alert.message));
      },
    );
  }

  handleSaveEventJobNotesSuccess(alert) {
    this.setState(
      {
        modalAddJobNote: alert.modal,
        fetchingData: false,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState(
            (prevState) => ({ alert: { ...prevState.alert, isOpen: false } }),
            () => {
              this.refreshSearch();
            },
          );
        }, Timeout(alert.message));
      },
    );
  }

  handleSaveEventCopyJobSuccess(alert) {
    this.setState(
      {
        modalCopyJob: alert.modal,
        selectedJob: null,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState(
            (prevState) => ({ alert: { ...prevState.alert, isOpen: false } }),
            () => {
              this.refreshSearch();
            },
          );
        }, Timeout(alert.message));
      },
    );
  }

  handleSortedData(sortedRows) {
    if (!Array.isArray(sortedRows)) {
      return;
    }

    this.setState({ workOrderList: sortedRows });
  }

  handleSortedDeletedJobs(sortedRows) {
    if (!Array.isArray(sortedRows)) {
      return;
    }

    this.setState({ deletedJobsList: sortedRows });
  }

  handlePurpleHistoryLoadingChange(isLoading) {
    const next = !!isLoading;
    if (this.state.purpleJobHistoryLoading === next) {
      return;
    }
    this.setState({ purpleJobHistoryLoading: next });
  }

  handleSearchChange(e) {
    const { name, value } = e.target;
    let model = { ...this.state.searchModel };

    // If the <select> is being used and name === 'MyJobsUserId',
    // then value is already the userId.
    if (this.props.isMyJob && name === "MyJobsUserId") {
      model.MyJobsUserId = value;
    } else {
      model[name] = value;
    }

    const isStartDate = name === "StartDate";
    const isEndDate = name === "EndDate";
    const isDateField = isStartDate || isEndDate;

    this.setState({ searchModel: model }, () => {
      if (name === "MyJobsUserId") {
        this.populateWorkOrderData();
        return;
      }

      if (!isDateField) {
        return;
      }

      const manualEdit = this.manualDateInput && this.manualDateInput[name];

      if (this.manualDateInput) {
        this.manualDateInput[name] = false;
      }

      if (manualEdit) {
        return;
      }

      this.refreshSearch();
    });
  }

  handleKeyDown(e) {
    const targetName = e && e.target && e.target.name;

    if (targetName === "StartDate" || targetName === "EndDate") {
      if (e.key === "Enter") {
        this.manualDateInput[targetName] = false;
      } else {
        this.manualDateInput[targetName] = true;
      }
    }

    if (e.key !== "Enter") {
      return;
    }

    const { tableView } = this.state;

    switch (tableView) {
      case "deletedjobs":
        this.populateDeletedJobsData();
        break;
      case "purplereport":
        this.populateWorkOrderPurpleReportData();
        break;
      case "pending":
        this.populateWorkOrderPendingData();
        break;
      case "finalconf":
        this.populateWorkOrderFinalConfirmationData();
        break;
      case "callback":
        this.populateWorkOrderCallbackData();
        break;
      case "remote":
        this.populateWorkOrderRemoteData();
        break;
      default:
        this.populateWorkOrderData();
        break;
    }
  }

  handleSearchFocus(e) {
    if (!e) return;
    if (this.state.multiFilter === false) {
      this.setState(
        {
          searchModel: {
            IntId: "",
            ClmId: "",
            JobNum: null,
            StartDate: "",
            EndDate: "",
            Claimant: "",
            ClmClaimNumberNoDash: "",
            CLMPhone: "",
            Interpreter: "",
            Rep: "",
            ClientAbbrv: "",
            ProviderName: "",
            WorkFlowId: this.props.WorkFlowId,
            MyJobsUser: this.state.searchModel.MyJobsUser,
            SortBy: this.state.searchModel.SortBy,
            SortDirection: this.state.searchModel.SortDirection,
          },
        },
        () => {},
      );

      if (e.target.value !== "") {
        let model = { ...this.state.searchModel };

        if (e.target.name === "StartDate" || e.target.name === "EndDate") {
          model[e.target.name] = moment(e.target.value).format("YYYY-MM-DD");
        } else model[e.target.name] = e.target.value;

        this.setState({ searchModel: model });
      }
    }

    if (e.target.name === "StartDate" && e.target.type !== "date") {
      e.target.type = "date";
    }
    if (e.target.name === "EndDate" && e.target.type !== "date") {
      e.target.type = "date";
    }
  }

  handleSearchBlur(e) {
    // No-op; keep to preserve existing focus handling without auto-refreshing on blur.
  }

  handleCheckAll = () => {
    this.setState(
      {
        checkAll: !this.state.checkAll,
        clearSelection: false,
      },
      () => {
        this.state.workOrderList.forEach((item) =>
          this.setState({ ["chk_" + item.jobNum]: this.state.checkAll }),
        );
      },
    );
  };

  unCheckAll = () => {
    this.state.workOrderList.forEach((item) =>
      this.setState({ ["chk_" + item.jobNum]: false }),
    );
    this.setState({ clearSelection: true });
  };

  handleCheckChange = (e, callback) => {
    this.setState(
      {
        [e.target.name]: e.target.checked,
        clearSelection: false,
      },
      () => {
        // After the checkbox state is updated, check if all items are unchecked
        const uncheckedItems = this.state.workOrderList.filter(
          (item) => !this.state["chk_" + item.jobNum],
        );

        this.setState(
          {
            checkAll: uncheckedItems.length === 0,
          },
          () => {
            // After setting the `checkAll` state, call the callback if provided
            if (callback && typeof callback === "function") {
              callback();
            }
          },
        );
      },
    );
  };

  resetChecks = () => {
    this.setState(
      {
        checkAll: false,
        clearSelection: true,
      },
      () => {
        this.state.workOrderList.forEach((item) =>
          this.setState({ ["chk_" + item.jobNum]: false }),
        );
      },
    );
  };

  handleClearChecksOnEmailModalClose() {
    this.setState({
      isModalOpen: false,
      clearSelection: true,
    });
  }

  handleCoveringEmailSent(jobId, flagSnapshot) {
    if (!jobId || !flagSnapshot) {
      return;
    }

    this.setState((prevState) => ({
      workOrderList: prevState.workOrderList.map((item) =>
        item.jobId === jobId ? { ...item, ...flagSnapshot } : item,
      ),
      selectedJob:
        prevState.selectedJob && prevState.selectedJob.jobId === jobId
          ? { ...prevState.selectedJob, ...flagSnapshot }
          : prevState.selectedJob,
    }));
  }

  handlePiggyBack() {
    let model = { ...this.state.searchModel };

    if (!model.StartDate || model.StartDate === "") {
      this.handleSaveEventSuccess({
        message: "Please select a Start Date to run PiggyBack on.",
        modal: false,
        color: "warning",
      });
      return;
    }

    this.setState({ fetchingData: true }, () => {
      FetchData("/piggyback", "POST", this.user.token, model)
        .then((data) => {
          if (data === "Success") {
            this.handleSaveEventSuccess({
              message: "PiggyBack Complete.",
              modal: false,
              color: "success",
            });
          } else {
            this.handleSaveEventSuccess({
              message: "PiggyBack Failed.",
              modal: false,
              color: "warning",
            });
          }
        })
        .catch((error) => {
          console.error("PiggyBack request failed:", error);
          this.handleSaveEventSuccess({
            message: "PiggyBack Failed.",
            modal: false,
            color: "warning",
          });
        })
        .finally(() => {
          this.setState({ fetchingData: false });
        });
    });
  }

  handleAutoPay() {
    this.setState({ tableView: "autopay" }, () => {
      let model = {
        JobDate: null,
        UserGID: "",
      };
      model.JobDate = this.state.searchModel.StartDate;
      model.UserGID = this.user.userid;
      FetchData("/autopay", "POST", this.user.token, model).then((data) => {
        if (data === "Success") {
          this.handleSaveEventSuccess({
            message: "AutoPay Complete.",
            modal: false,
            color: "success",
          });
        } else {
          this.handleSaveEventSuccess({
            message: "AutoPay Failed." + data,
            modal: false,
            color: "warning",
          });
        }
      });
    });
  }

  handleIntConfNo(workorder) {
    let model = {
      UserID: this.user.userid,
      FirstName: this.user.firstname,
      LastName: this.user.lastname,
      Email: this.user.email,
      JobId: workorder.jobId,
      IntId: workorder.intId,
    };

    FetchData(
      "/finalconfirmationemailtointerpreter",
      "POST",
      this.user.token,
      model,
    ).then((data) => {
      let alertColor = "warning"; // Default to warning
      let alertMessage = "Error sending email";
      if (
        (data.msgEmail === "Success" || data.msgEmail === "Email Sent") &&
        data.msgJobHistory === "Success" &&
        data.msgUser === "Success"
      ) {
        alertColor = "success";
        alertMessage = "Email Sent";
      } else {
        if (
          (data.msgEmail === "Success" || data.msgEmail === "Email Sent") &&
          data.msgUser !== "Success"
        ) {
          alertMessage = "Error creating user for Interpreter, Contact Support";
        }
      }

      this.setState(
        {
          alert: {
            color: alertColor,
            message: alertMessage,
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    });
  }

  async handleSendSMS(workorder) {
    let model = {
      User: {
        UserID: this.user.userid,
        FirstName: this.user.firstname,
        LastName: this.user.lastname,
        Email: this.user.email,
        IntId: workorder.intId,
      },
      JobId: workorder.jobId,
    };

    await FetchData(
      "/RingPlanSendMessage",
      "POST",
      this.user.token,
      model,
    ).then((data) => {
      this.setState(
        {
          alert: {
            message: data,
            modal: data === "Success" ? false : true,
            color: data === "Success" ? "success" : "warning",
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(data));
        },
      );
    });
  }

  handleIntCheckin(workorder) {
    let model = {
      UserID: this.user.userid,
      FirstName: this.user.firstname,
      LastName: this.user.lastname,
      Email: this.user.email,
      JobId: workorder.jobId,
      IntId: workorder.intId,
    };

    FetchData(
      "/interpretersendcheckinemail",
      "POST",
      this.user.token,
      model,
    ).then((data) => {
      let alertColor = "warning"; // Default to warning
      let alertMessage = "Error sending email";
      if (
        (data.msgEmail === "Success" || data.msgEmail === "Email Sent") &&
        data.msgJobHistory === "Success" &&
        data.msgUser === "Success"
      ) {
        alertColor = "success";
        alertMessage = "Email Sent";
      } else {
        if (
          (data.msgEmail === "Success" || data.msgEmail === "Email Sent") &&
          data.msgUser !== "Success"
        ) {
          alertMessage = "Error creating user for Interpreter, Contact Support";
        }
      }

      this.setState(
        {
          alert: {
            color: alertColor,
            message: alertMessage,
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    });
  }

  handlePrevNextButton = (day) => {
    if (
      this.state.searchModel.StartDate === "" ||
      this.state.searchModel.StartDate === null
    ) {
      alert("Please enter Job Start Date");
    } else {
      const nextDate = moment(this.state.searchModel.StartDate)
        .add(day, "d")
        .format("YYYY-MM-DD");

      this.setState(
        (prevState) => ({
          searchModel: { ...prevState.searchModel, StartDate: nextDate },
          selectedJob: null,
        }),
        () => {
          this.refreshSearch();
        },
      );
    }
  };

  viewJobNotes(workorder) {
    FetchData("/getreceivables", "POST", this.user.token, {
      JobId: workorder.jobId,
    }).then((data) => {
      this.setState({ receivableList: data });
    });
    FetchData("/getreceivableitems", "POST", this.user.token, {
      JobId: workorder.jobId,
    }).then((data) => {
      this.setState({ receivableItemList: data });
    });
    this.setModalWOJobNotes();
  }

  viewInvoice(woData, i) {
    let body = {
      JobIdsList: "",
    };

    body.JobIdsList = woData.jobId;
    let currentDate = new Date();
    let invoiceFileName =
      "Invoice " +
      woData.jobNum +
      " " +
      (currentDate.getMonth() + 1) +
      "-" +
      currentDate.getDate() +
      "-" +
      currentDate.getFullYear() +
      ".pdf";

    FetchFile("/printinvoices", "POST", this.user.token, body).then((blob) => {
      if (!blob || blob.size === 0) {
        this.setState(
          {
            alert: {
              color: "warning",
              message: "No file returned.",
              isOpen: true,
            },
          },
          () => {
            window.setTimeout(
              () => this.setState({ alert: { isOpen: false } }),
              Timeout("No file returned."),
            );
          },
        );
        return;
      }
      openFileInNewTab(blob, invoiceFileName);
    });
  }

  handleRepEmailClick() {
    let jobNumsList = [];
    let repList = [];
    var sameRepSelected = true;
    this.state.workOrderList.forEach((item) => {
      if (this.state["chk_" + item.jobNum]) {
        jobNumsList.push(item);
        if (repList.length === 0) {
          repList.push(item.repEmail);
        } else {
          for (var i = 0; i < repList.length; i++) {
            if (repList[i] !== item.repEmail) {
              sameRepSelected = false;
              break;
            }
          }
        }
      }
    });

    if (repList.length === 0) {
      this.setState(
        {
          alert: {
            color: "warning",
            message: "Please select one or more work orders with the same rep.",
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    } else if (!sameRepSelected) {
      this.setState(
        {
          alert: {
            color: "warning",
            message: "Selected Reps are not the same.",
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    } else {
      var body = "Dear " + jobNumsList[0].repFirstName + ",";

      var subject =
        jobNumsList[0].clmFirstName +
        " " +
        jobNumsList[0].clmLastName +
        " CLM # " +
        jobNumsList[0].clmClaimNumber;

      body += "\n\n";
      body +=
        '<table style="width:100%;border: 1px solid black;border-collapse: collapse;">';
      body += '<tr style="border: 1px solid black">';
      body +=
        '<td style="border: 1px solid black">JobID</td><td style="border: 1px solid black">Appointment Date Time</td><td style="border: 1px solid black">Provider</td><td style="border: 1px solid black">Location</td>';
      body += "</tr>";
      for (var i = 0; i < jobNumsList.length; i++) {
        var d = new Date(jobNumsList[i].jobDateTime);

        body += '<tr style="border: 1px solid black">';
        body +=
          '<td style="border: 1px solid black">' +
          jobNumsList[i].jobNum +
          "</td>";
        //
        body +=
          '<td style="border: 1px solid black">' +
          moment(jobNumsList[i].jobDateTime).format("MM/DD/YYYY") +
          " (" +
          this.state.dayNames[d.getDay()] +
          ") " +
          moment(jobNumsList[i].jobDateTime).format("hh:mm A") +
          "</td>";
        //
        body +=
          '<td style="border: 1px solid black">' +
          jobNumsList[i].providerName +
          "</td>";
        //
        body +=
          '<td style="border: 1px solid black">' +
          jobNumsList[i].aptStreet +
          "," +
          jobNumsList[i].aptCity +
          "," +
          jobNumsList[i].aptState +
          "," +
          jobNumsList[i].aptZip +
          "</td>";
        body += "</tr>";
      }
      body += "</table>";

      body += "\n\nThank you,";
      body += "\n" + this.user.firstname + " " + this.user.lastname;

      body +=
        "\n\nExecutive Linguist Agency \n800-522-2320 | Text: 310-955-4513 | 8am - 5pm Nationwide \nAfter-hours Emergencies: 310-749-6521 or 562-682-3924 \nQuestions: mail@executivelinguist.com";

      this.setState((prevState) => ({
        email: {
          EmailFrom: this.user.email,
          EmailTo: jobNumsList[0].repEmail,
          EmailCC: "",
          Subject: subject,
          Body: body,
          JobIds: jobNumsList.map((u) => u.jobId).join(","),
          JobNums: jobNumsList.map((u) => u.jobNum).join(","),
          EmailType: "email2",
          CreatedByUserId: this.user.userid,
        },
      }));
      this.setModalRepFormEmail();
    }
  }

  async handleRepAuthorizationsClick() {
    let jobNumsList = [];
    let repList = [];
    var sameRepSelected = true;
    this.state.workOrderList.forEach((item) => {
      if (this.state["chk_" + item.jobNum]) {
        jobNumsList.push(item);
        if (repList.length === 0) {
          repList.push(item.repEmail);
        } else {
          for (var i = 0; i < repList.length; i++) {
            if (repList[i] !== item.repEmail) {
              sameRepSelected = false;
              break;
            }
          }
        }
      }
    });

    if (repList.length === 0) {
      this.setState(
        {
          alert: {
            color: "warning",
            message: "Please select one or more work orders with the same rep.",
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    } else if (!sameRepSelected) {
      this.setState(
        {
          alert: {
            color: "warning",
            message: "Selected Reps are not the same.",
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    } else {
      const clientData = await FetchData("/getclients", "POST", this.user.token, {
        ClientId: jobNumsList[0].clientId,
      });
      const client = Array.isArray(clientData) ? clientData[0] : null;
      const feeAuth = client?.feeAuth ?? null;

      const senderName = `${this.user.firstname} ${this.user.lastname}`;

      this.setState((prevState) => ({
        selectedJob: jobNumsList[0],
        email: {
          EmailFrom: this.user.email,
          EmailTo: jobNumsList[0].repEmail,
          EmailCC: "mail@executivelinguist.com",
          Subject: buildAuthEmailSubjectMulti(jobNumsList),
          Body: buildAuthEmailBodyMulti(jobNumsList, feeAuth, senderName),
          JobIds: jobNumsList.map((u) => u.jobId).join(","),
          JobNums: jobNumsList.map((u) => u.jobNum).join(","),
          EmailType: "email1",
          EmailSource: "RepEmail",
          CreatedByUserId: this.user.userid,
        },
      }));
      this.setModalRepFormEmail();
    }
  }

  handleIntEmailClick() {
    let jobList = [];
    let emailList = [];
    var sameIntSelected = true;

    this.state.workOrderList.forEach((item) => {
      if (this.state["chk_" + item.jobNum]) {
        jobList.push(item);
        if (emailList.length === 0) emailList.push(item.intEmail);
        else {
          for (var i = 0; i < emailList.length; i++) {
            if (emailList[i] !== item.intEmail) {
              sameIntSelected = false;
              break;
            }
          }
        }
      }
    });

    if (emailList.length === 0) {
      this.setState(
        {
          alert: {
            color: "warning",
            message:
              "Please select one or more work orders with the same interpreter.",
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    } else if (!sameIntSelected) {
      this.setState(
        {
          alert: {
            color: "warning",
            message: "Selected Interpreters are not the same.",
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    } else {
      var body = "Dear " + jobList[0].intFirstName + ",";
      body +=
        "\n\n---\nFor privacy reasons, we have replaced the claimant's name with their claim number in this communication. The claimant's full name can be viewed inside the portal.";
      body +=
        "\n\nPlease ** REPLY TO THIS EMAIL ** to confirm this is in your book:";

      body += "\n\n";
      body +=
        '<table style="width:100%;border: 1px solid black;border-collapse: collapse;">';
      body += '<tr style="border: 1px solid black">';
      body +=
        '<td style="border: 1px solid black">JobID</td><td style="border: 1px solid black">Claim #</td><td style="border: 1px solid black">Appointment Date Time</td><td style="border: 1px solid black">Provider</td><td style="border: 1px solid black">Location</td>';
      body += "</tr>";
      for (var i = 0; i < jobList.length; i++) {
        var d = new Date(jobList[i].jobDateTime);

        body += '<tr style="border: 1px solid black">';
        body +=
          '<td style="border: 1px solid black">' + jobList[i].jobNum + "</td>";
        //
        body +=
          '<td style="border: 1px solid black">Claim #' +
          jobList[i].clmClaimNumber +
          "</td>";
        body +=
          '<td style="border: 1px solid black">' +
          moment(jobList[i].jobDateTime).format("MM/DD/YYYY") +
          " (" +
          this.state.dayNames[d.getDay()] +
          ") " +
          moment(jobList[i].jobDateTime).format("hh:mm A") +
          "</td>";
        //
        body +=
          '<td style="border: 1px solid black">' +
          jobList[i].providerName +
          "</td>";
        //
        body +=
          '<td style="border: 1px solid black">' +
          jobList[i].aptStreet +
          "," +
          jobList[i].aptCity +
          "," +
          jobList[i].aptState +
          "," +
          jobList[i].aptZip +
          "</td>";
        body += "</tr>";
      }
      body += "</table>";

      body +=
        "\n\nIf there is any problem or if the patient does not appear within 15 mins of start time, please CALL US right away. If you are not required to interpret, you MUST call us BEFORE leaving the appointment. ";

      body +=
        "\n\nExecutive Linguist Agency, Inc. requires its contracted interpreters to follow all local, state, and federal health guidelines and mandates.";
      body +=
        "\n\nMore medical offices are requiring proof of vaccination. If you are vaccinated, Executive Linguist recommends carrying proof of vaccination with you.";
      body +=
        "\n\nIf you encounter a situation at a scheduled appointment where guidelines and mandates are not followed, please call us immediately.";

      body += `\n\nTo access our Portal and FAQ click at <a href='${PORTAL_URL}' target="_blank">${PORTAL_URL}</a>`;

      body += "\n\nThank you,";
      body += "\n" + this.user.firstname + " " + this.user.lastname;

      body +=
        "\n\nExecutive Linguist Agency \n800-522-2320 | Text: 310-955-4513 | 8am - 5pm Nationwide \n After-hours Emergencies: 310-749-6521 or 562-682-3924 \nQuestions: mail@executivelinguist.com";

      this.setState((prevState) => ({
        showButtons: "cancellation,remote_email,covering_email",
        email: {
          EmailFrom: this.user.email,
          EmailTo: jobList[0].intEmail,
          EmailCC: "",
          Subject: "Interpreting Assignment",
          Body: body,
          JobIds: jobList.map((u) => u.jobId).join(","),
          CreatedByUserId: this.user.userid,
        },
      }));
      this.setModalIntFormEmail();
    }
  }

  handleCopyJob() {
    let jobNumsList = [];

    this.state.workOrderList.forEach((item) => {
      if (this.state["chk_" + item.jobNum]) {
        jobNumsList.push(item.jobNum);
      }
    });

    if (jobNumsList.length > 1) {
      this.setState(
        {
          alert: {
            color: "warning",
            message: "You can only copy one job at a time.",
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    } else if (jobNumsList.length === 1) {
      this.setState(
        {
          selectedJob: this.state.workOrderList.find(
            (item) => item.jobNum === jobNumsList[0],
          ),
        },
        () => {
          if (this.state.selectedJob !== null) {
            this.setState(
              (prevState) => ({
                model: {
                  EventType: "update",
                  JobNum: this.state.selectedJob.jobNum,
                  JobId: this.state.selectedJob.jobId,
                  JobDateTime: this.state.selectedJob.jobDateTime,
                  JobTypeName: this.state.selectedJob.jobTypeName,
                  JobTime: this.state.selectedJob.jobTime,
                  FinishTime: this.state.selectedJob.finishTime,
                  FinishTimeString:
                    this.state.selectedJob.finishTimeString === "00:00"
                      ? null
                      : this.state.selectedJob.finishTimeString,
                  FollowupDate: this.state.selectedJob.followupDate,
                  ProvId: this.state.selectedJob.provId,
                  ProviderName: this.state.selectedJob.providerName,
                  ConfCallNote: this.state.selectedJob.confCallNote,
                  AptName: this.state.selectedJob.aptName,
                  AptStreet: this.state.selectedJob.aptStreet,
                  AptCity: this.state.selectedJob.aptCity,
                  AptState: this.state.selectedJob.aptState,
                  AptZip: this.state.selectedJob.aptZip,
                  AptPhone: this.state.selectedJob.aptPhone,
                  AptDirection: this.state.selectedJob.aptDirection,
                  FailedFlg: this.state.selectedJob.failedFlg,
                  CallerNote: this.state.selectedJob.callerNote,
                  InvoiceNote: this.state.selectedJob.invoiceNote,
                  IntCheckDate: this.state.selectedJob.intCheckDate,
                  IntCheckNum: this.state.selectedJob.intCheckNum,
                  InvoicedFlg: this.state.selectedJob.invoicedFlg,
                  JobTotal: this.state.selectedJob.jobTotal,
                  JobDiscount: this.state.selectedJob.jobDiscount,
                  IntFee:
                    this.state.selectedJob.intFee === null
                      ? null
                      : parseInt(this.state.selectedJob.intFee),
                  IntFeeOther:
                    this.state.selectedJob.intFeeOther === null
                      ? null
                      : parseInt(this.state.selectedJob.intFeeOther),
                  IntOTFee:
                    this.state.selectedJob.intOTFee === null
                      ? null
                      : parseInt(this.state.selectedJob.intOTFee),
                  IntFeeNote: this.state.selectedJob.intFeeNote,
                  TransportationFlg: this.state.selectedJob.transportationFlg,
                  TransConfFlg: this.state.selectedJob.transConfFlg,
                  IntConfFlg: this.state.selectedJob.intConfFlg,
                  AppointmentTypeId: this.state.selectedJob.appointmentTypeId,
                  CallerType: this.state.selectedJob.callerType,
                  ProvConfFlg: this.state.selectedJob.provConfFlg,
                  ClmConfFlg: this.state.selectedJob.clmConfFlg,
                  IsDeletedFlg: this.state.selectedJob.isDeletedFlg,
                  BillReviewedFlg: this.state.selectedJob.billReviewedFlg,
                  AuditFlg: this.state.selectedJob.auditFlg,
                  PurpleReportFlg: this.state.selectedJob.purpleReportFlg,
                  RepAuthorizedFlg: this.state.selectedJob.repAuthorizedFlg,
                  SelectedFlg: this.state.selectedJob.selectedFlg,
                  ClmId: this.state.selectedJob.clmId,
                  ClmFirstName: this.state.selectedJob.clmFirstName,
                  ClmLastName: this.state.selectedJob.clmLastName,
                  ClmClaimNumber: this.state.selectedJob.clmClaimNumber,
                  ClmClaimNumberNoDash:
                    this.state.selectedJob.clmClaimNumberNoDash,
                  ClmPhone: this.state.selectedJob.clmPhone,
                  ClmDateOfLoss: this.state.selectedJob.clmDateOfLoss,
                  ClmDateOfInjury: this.state.selectedJob.clmDateOfInjury,
                  ClmDateOfInjuryStart:
                    this.state.selectedJob.clmDateOfInjuryStart,
                  ClmDateOfInjuryEnd: this.state.selectedJob.clmDateOfInjuryEnd,
                  ClmDateOfLossDate: this.state.selectedJob.clmDateOfLossDate,
                  ClmNote: this.state.selectedJob.clmNote,
                  ClmDOB: this.state.selectedJob.clmDOB,
                  ClmInsuredParty: this.state.selectedJob.clmInsuredParty,
                  ClmEmployer: this.state.selectedJob.clmEmployer,
                  ClmInvoiceCaption: this.state.selectedJob.clmInvoiceCaption,
                  ClmLanguage: this.state.selectedJob.clmLanguage,
                  ClmWCABNumber: this.state.selectedJob.clmWCABNumber,
                  ClmInvoiceType: this.state.selectedJob.clmInvoiceType,
                  ClmStreet: this.state.selectedJob.clmStreet,
                  ClmCity: this.state.selectedJob.clmCity,
                  ClmState: this.state.selectedJob.clmState,
                  ClmZip: this.state.selectedJob.clmZip,
                  ClmSSN: this.state.selectedJob.clmSSN,
                  ClmOrderedByName: this.state.selectedJob.clmOrderedByName,
                  ClmDiagnosis: this.state.selectedJob.clmDiagnosis,
                  ClmEmail: this.state.selectedJob.clmEmail,
                  ClmHasAttorneyFlg: this.state.selectedJob.clmHasAttorneyFlg,
                  RepId: this.state.selectedJob.repId,
                  RepFirstName: this.state.selectedJob.repFirstName,
                  RepLastName: this.state.selectedJob.repLastName,
                  RepPhone: this.state.selectedJob.repPhone,
                  RepEmail: this.state.selectedJob.repEmail,
                  ClientId: this.state.selectedJob.clientId,
                  ClientAbbrv: this.state.selectedJob.clientAbbrv,
                  ClientName: this.state.selectedJob.clientName,
                  ClientStreet: this.state.selectedJob.clientStreet,
                  ClientStreet2: this.state.selectedJob.clientStreet2,
                  ClientCity: this.state.selectedJob.clientCity,
                  ClientState: this.state.selectedJob.clientState,
                  ClientZip: this.state.selectedJob.clientZip,
                  ClientMailStreet: this.state.selectedJob.clientMailStreet,
                  ClientMailStreet2: this.state.selectedJob.clientMailStreet2,
                  ClientMailCity: this.state.selectedJob.clientMailCity,
                  ClientMailState: this.state.selectedJob.clientMailState,
                  ClientMailZip: this.state.selectedJob.clientMailZip,
                  ClientPhone: this.state.selectedJob.clientPhone,
                  ClientPhoneFax: this.state.selectedJob.clientPhoneFax,
                  ClientPhone2: this.state.selectedJob.clientPhone2,
                  ClientEmail: this.state.selectedJob.clientEmail,
                  ClientInactiveFlg: this.state.selectedJob.clientInactiveFlg,
                  IntId: this.state.selectedJob.intId,
                  IntLastName: this.state.selectedJob.intLastName,
                  IntFirstName: this.state.selectedJob.intFirstName,
                  IntCellTxt: this.state.selectedJob.intCellTxt,
                  IntPhoneOnly: this.state.selectedJob.intPhoneOnly,
                  IntEmail: this.state.selectedJob.intEmail,
                  IntNote: this.state.selectedJob.intNote,
                  InHouseFlg: this.state.selectedJob.inHouseFlg,
                  IntCity: this.state.selectedJob.intCity,
                  IntStreet: this.state.selectedJob.intStreet,
                  IntState: this.state.selectedJob.intState,
                  IntZip: this.state.selectedJob.intZip,
                  DBA: this.state.selectedJob.dDBA,
                  Rate: this.state.selectedJob.rate,
                  HourMinimum: this.state.selectedJob.hourMinimum,
                  Prorate: this.state.selectedJob.prorate,
                  BankRoute: this.state.selectedJob.bankRoute,
                  BankAccount: this.state.selectedJob.bankAccount,
                  IntSSINumber: this.state.selectedJob.intSSINumber,
                  FirstName: this.state.selectedJob.firstName,
                  LastName: this.state.selectedJob.lastName,
                  UserType: this.state.selectedJob.userType,
                  UserIntId: this.state.selectedJob.userIntId,
                  CreateDateTime: this.state.selectedJob.createDateTime,
                  CreateByUserId: this.state.selectedJob.createByUserId,
                  UpdateDateTime: this.state.selectedJob.updateDateTime,
                  UpdateByUserId: this.state.selectedJob.updateByUserId,
                  RemIntFlg: this.state.selectedJob.remIntFlg,
                  RemClaimFlg: this.state.selectedJob.remClaimFlg,
                  RemProvFlg: this.state.selectedJob.remProvFlg,
                  RemFinalFlg: this.state.selectedJob.remFinalFlg,
                  RemType: this.state.selectedJob.remType,
                  RemTypeDesc: this.state.selectedJob.remTypeDesc,
                  RemHost: this.state.selectedJob.remHost,
                  RemHostDesc: this.state.selectedJob.remHostDesc,
                  CreatedBy: this.state.selectedJob.createdBy,
                  UpdatedBy: this.state.selectedJob.updatedBy,
                  MyJobTJobHistory: this.state.selectedJob.myJobTJobHistory,
                  MyJobWaitingOnCallBack:
                    this.state.selectedJob.myJobWaitingOnCallBack,
                  JobBalance: this.state.selectedJob.jobBalance,
                  WorkFlowId: this.state.selectedJob.workFlowId,
                },
              }),
              () => {
                this.setModalCopyJob();
              },
            );
          } else {
            this.setState(
              {
                alert: {
                  color: "warning",
                  message: "No record selected.",
                  isOpen: true,
                },
              },
              () => {
                window.setTimeout(() => {
                  this.setState({ alert: { isOpen: false } });
                }, Timeout(alert.message));
              },
            );
          }
        },
      );
    } else {
      this.setState(
        {
          alert: {
            color: "warning",
            message: "No record selected.",
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    }
  }

  handleAddJobNoteClick() {
    let jobNumsList = [];
    let jobIdList = [];

    this.state.workOrderList.forEach((item) => {
      if (this.state["chk_" + item.jobNum]) {
        jobNumsList.push(item.jobNum);
        jobIdList.push(item.jobId);
      }
    });
    var jobNumbers = jobNumsList.join();

    if (jobNumbers === "") {
      this.setState(
        {
          alert: {
            color: "warning",
            message: "Please select one or more workorders to add notes to",
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    } else {
      let model = { ...this.state.jobNotes };
      model.JobNumbers = jobNumbers;
      model.JobIds = jobIdList.join();
      model.JobHistory = [];

      this.setState({ jobNotes: model }, () => {
        this.setModalAddJobNote();
      });
    }
  }

  async exportPDF() {
    let jobNumsList = [];
    let body = {
      JobNumbers: "",
    };

    this.state.workOrderList.forEach((item) => {
      if (this.state["chk_" + item.jobNum]) {
        jobNumsList.push(item.jobNum);
      }
    });
    body.JobNumbers = jobNumsList.join();

    if (body.JobNumbers === "") {
      this.setState(
        {
          alert: {
            color: "warning",
            message: "Please check any work order",
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    } else {
      await FetchFile("/getinvoices", "POST", this.user.token, body).then(
        (blob) => {
          if (!blob || blob.size === 0) {
            this.setState(
              {
                alert: {
                  color: "warning",
                  message: "No file returned.",
                  isOpen: true,
                },
              },
              () => {
                window.setTimeout(
                  () => this.setState({ alert: { isOpen: false } }),
                  Timeout("No file returned."),
                );
              },
            );
            return;
          }
          openFileInNewTab(blob, 'Invoices.pdf');
        },
      );
    }
  }

  async populateWorkOrderDataRefresh() {
    this.setState({ fetchingData: true });

    let model = { ...this.state.searchModel };
    model.StartDate =
      model.StartDate === "" || model.StartDate === null
        ? null
        : moment(model.StartDate).format("YYYY-MM-DD");
    model.EndDate =
      model.EndDate === "" || model.EndDate === null
        ? null
        : moment(model.EndDate).format("YYYY-MM-DD");
    model.MyJobs = this.props.isMyJob;

    if (model.JobNum === "") {
      model.JobNum = null;
    }

    if (this.props.isMyJob) {
      model.CreatedByUserId = this.user.userid;

      this.setState({ searchModel: model }, () => {
        if (model.MyJobsUserId === "") {
          FetchData(
            "/getmyjobs?userId=" + this.user.userid,
            "POST",
            this.user.token,
            null,
          ).then((data) => {
            const safeData = Array.isArray(data) ? data : [];
            this.setState({
              workOrderList: safeData,
              loading: false,
              fetchingData: false,
            });
          });
        } else {
          FetchData(
            "/getmyjobs?userId=" + model.MyJobsUserId,
            "POST",
            this.user.token,
            null,
          ).then((data) => {
            const safeData = Array.isArray(data) ? data : [];
            this.setState({
              workOrderList: safeData,
              loading: false,
              fetchingData: false,
            });
          });
        }
      });
    } else {
      this.setState({ searchModel: model }, () => {
        FetchData("/getworkorders", "POST", this.user.token, model).then(
          (data) => {
            const safeData = Array.isArray(data) ? data : [];
            this.setState({
              workOrderList: safeData,
              loading: false,
              fetchingData: false,
            });
          },
        );
      });
    }

    this.resetChecks();
  }

  async populateDeletedJobsData() {
    this.setState({ fetchingData: true });

    let model = { ...this.state.searchModel };
    model.StartDate =
      model.StartDate === "" || model.StartDate === null
        ? null
        : moment(model.StartDate).format("YYYY-MM-DD");
    model.EndDate =
      model.EndDate === "" || model.EndDate === null
        ? null
        : moment(model.EndDate).format("YYYY-MM-DD");
    //model.MyJobs = this.props.isMyJob;
    if (model.JobNum === "") {
      model.JobNum = null;
    }

    let url = "/getdeletedjobs";

    this.setState({ searchModel: model }, () => {
      FetchData(url, "POST", this.user.token, model).then((data) => {
        this.setState({
          deletedJobsList: data,
          loading: false,
          fetchingData: false,
          tableView: "deletedjobs",
        });
      });
    });
  }

  async populateWorkOrderData() {
    this.setState({ fetchingData: true });

    let model = { ...this.state.searchModel };
    model.StartDate =
      model.StartDate === "" || model.StartDate === null
        ? null
        : moment(model.StartDate).format("YYYY-MM-DD");
    model.EndDate =
      model.EndDate === "" || model.EndDate === null
        ? null
        : moment(model.EndDate).format("YYYY-MM-DD");
    model.MyJobs = this.props.isMyJob;

    if (model.JobNum === "") {
      model.JobNum = null;
    }

    if (this.props.isMyJob) {
      model.CreatedByUserId = this.user.userid;

      this.setState({ searchModel: model }, () => {
        if (model.MyJobsUserId === "") {
          FetchData(
            "/getmyjobs?userId=" + this.user.userid,
            "POST",
            this.user.token,
            null,
          ).then((data) => {
            const safeData = Array.isArray(data) ? data : [];
            this.setState({
              workOrderList: safeData,
              loading: false,
              fetchingData: false,
            });
          });
        } else {
          FetchData(
            "/getmyjobs?userId=" + model.MyJobsUserId,
            "POST",
            this.user.token,
            null,
          ).then((data) => {
            const safeData = Array.isArray(data) ? data : [];
            this.setState({
              workOrderList: safeData,
              loading: false,
              fetchingData: false,
            });
          });
        }
      });
    } else {
      this.setState({ searchModel: model }, () => {
        FetchData("/getworkorders", "POST", this.user.token, model).then(
          (data) => {
            const safeData = Array.isArray(data) ? data : [];
            this.setState({
              workOrderList: safeData,
              loading: false,
              fetchingData: false,
            });
          },
        );
      });
    }

    this.resetChecks();
    //await FetchData("/getworkorders", "POST", this.user.token, this.state.searchModel).then(data => {
    //    this.setState({ workOrderList: data, loading: false, fetchingData: false });
    //});
  }

  async openWorkOrderForm(jobId) {
    FetchData(
      "/getworkorder?jobId=" + jobId,
      "POST",
      this.user.token,
      null,
    ).then((data) => {
      this.setState((prevState) => ({
        model: {
          EventType: "update",
          JobNum: data.jobNum,
          JobId: data.jobId,
          JobDateTime: data.jobDateTime,
          JobTypeName: data.jobTypeName,
          JobTime: data.jobTime,
          FinishTime: data.finishTime,
          FinishTimeString:
            data.finishTimeString === "00:00" ? null : data.finishTimeString,
          FollowupDate: data.followupDate,
          ProvId: data.provId,
          ProviderName: data.providerName,
          ConfCallNote: data.confCallNote,
          AptName: data.aptName,
          AptStreet: data.aptStreet,
          AptCity: data.aptCity,
          AptState: data.aptState,
          AptZip: data.aptZip,
          AptPhone: data.aptPhone,
          AptDirection: data.aptDirection,
          FailedFlg: data.failedFlg,
          CallerNote: data.callerNote,
          InvoiceNote: data.invoiceNote,
          IntCheckDate: data.intCheckDate,
          IntCheckNum: data.intCheckNum,
          InvoicedFlg: data.invoicedFlg,
          IntFinalConfEmailSentFlg: data.IntFinalConfEmailSentFlg,
          JobTotal: data.jobTotal,
          JobDiscount: data.jobDiscount,
          IntFee: data.intFee === null ? null : parseInt(data.intFee),
          IntFeeOther:
            data.intFeeOther === null ? null : parseInt(data.intFeeOther),
          IntOTFee: data.intOTFee === null ? null : parseInt(data.intOTFee),
          IntFeeNote: data.intFeeNote,
          TransportationFlg: data.transportationFlg,
          TransConfFlg: data.transConfFlg,
          IntConfFlg: data.intConfFlg,
          AppointmentTypeId: data.appointmentTypeId,
          CallerType: data.callerType,
          ProvConfFlg: data.provConfFlg,
          ClmConfFlg: data.clmConfFlg,
          IsDeletedFlg: data.isDeletedFlg,
          BillReviewedFlg: data.billReviewedFlg,
          AuditFlg: data.auditFlg,
          PurpleReportFlg: data.purpleReportFlg,
          RepAuthorizedFlg: data.repAuthorizedFlg,
          SelectedFlg: data.selectedFlg,
          ClmId: data.clmId,
          ClmFirstName: data.clmFirstName,
          ClmLastName: data.clmLastName,
          ClmClaimNumber: data.clmClaimNumber,
          ClmClaimNumberNoDash: data.clmClaimNumberNoDash,
          ClmPhone: data.clmPhone,
          ClmDateOfLoss: data.clmDateOfLoss,
          ClmDateOfInjury: data.clmDateOfInjury,
          ClmDateOfInjuryStart: data.clmDateOfInjuryStart,
          ClmDateOfInjuryEnd: data.clmDateOfInjuryEnd,
          ClmDateOfLossDate: data.clmDateOfLossDate,
          ClmNote: data.clmNote,
          ClmDOB: data.clmDOB,
          ClmInsuredParty: data.clmInsuredParty,
          ClmEmployer: data.clmEmployer,
          ClmInvoiceCaption: data.clmInvoiceCaption,
          ClmLanguage: data.clmLanguage,
          ClmWCABNumber: data.clmWCABNumber,
          ClmInvoiceType: data.clmInvoiceType,
          ClmStreet: data.clmStreet,
          ClmCity: data.clmCity,
          ClmState: data.clmState,
          ClmZip: data.clmZip,
          ClmSSN: data.clmSSN,
          ClmOrderedByName: data.clmOrderedByName,
          ClmDiagnosis: data.clmDiagnosis,
          ClmEmail: data.clmEmail,
          ClmHasAttorneyFlg: data.clmHasAttorneyFlg,
          RepId: data.repId,
          RepFirstName: data.repFirstName,
          RepLastName: data.repLastName,
          RepPhone: data.repPhone,
          RepEmail: data.repEmail,
          ClientId: data.clientId,
          ClientAbbrv: data.clientAbbrv,
          ClientName: data.clientName,
          ClientStreet: data.clientStreet,
          ClientStreet2: data.clientStreet2,
          ClientCity: data.clientCity,
          ClientState: data.clientState,
          ClientZip: data.clientZip,
          ClientMailStreet: data.clientMailStreet,
          ClientMailStreet2: data.clientMailStreet2,
          ClientMailCity: data.clientMailCity,
          ClientMailState: data.clientMailState,
          ClientMailZip: data.clientMailZip,
          ClientPhone: data.clientPhone,
          ClientPhoneFax: data.clientPhoneFax,
          ClientPhone2: data.clientPhone2,
          ClientEmail: data.clientEmail,
          ClientInactiveFlg: data.clientInactiveFlg,
          IntId: data.intId,
          IntLastName: data.intLastName,
          IntFirstName: data.intFirstName,
          IntCellTxt: data.IntCellTxt,
          IntPhoneOnly: data.IntPhoneOnly,
          IntEmail: data.intEmail,
          IntNote: data.intNote,
          InHouseFlg: data.inHouseFlg,
          IntCity: data.intCity,
          IntStreet: data.intStreet,
          IntState: data.intState,
          IntZip: data.intZip,
          DBA: data.dDBA,
          Rate: data.rate,
          HourMinimum: data.hourMinimum,
          Prorate: data.prorate,
          BankRoute: data.bankRoute,
          BankAccount: data.bankAccount,
          IntSSINumber: data.intSSINumber,
          FirstName: data.firstName,
          LastName: data.lastName,
          UserType: data.userType,
          UserIntId: data.userIntId,
          CreateDateTime: data.createDateTime,
          CreateByUserId: data.createByUserId,
          UpdateDateTime: data.updateDateTime,
          UpdateByUserId: data.updateByUserId,
          RemIntFlg: data.remIntFlg,
          RemClaimFlg: data.remClaimFlg,
          RemProvFlg: data.remProvFlg,
          RemFinalFlg: data.remFinalFlg,
          RemType: data.remType,
          RemTypeDesc: data.remTypeDesc,
          RemHost: data.remHost,
          RemHostDesc: data.remHostDesc,
          CreatedBy: data.createdBy,
          UpdatedBy: data.updatedBy,
          MyJobTJobHistory: data.myJobTJobHistory,
          JobBalance: data.jobBalance,
        },
        selectedIndex: 0,
        modal: true,
      }));
    });
  }

  async populateWorkOrderPurpleReportData() {
    this.setState({ fetchingData: true });

    let model = { ...this.state.searchModel };
    const normalizeDate = (value) => {
      if (!value) {
        return value;
      }

      const parsed = moment(value);
      return parsed.isValid() ? parsed.format("YYYY-MM-DD") : value;
    };

    model.StartDate = normalizeDate(model.StartDate);
    model.EndDate = normalizeDate(model.EndDate);

    await FetchData(
      "/getworkorderspurplereport",
      "POST",
      this.user.token,
      model,
    ).then((data) => {
      const workOrders =
        Array.isArray(data?.workOrders) && data.workOrders.length
          ? data.workOrders
          : Array.isArray(data?.WorkOrders) && data.WorkOrders.length
            ? data.WorkOrders
            : Array.isArray(data)
              ? data
              : [];
      const jobHistoryList =
        Array.isArray(data?.jobHistoryList) && data.jobHistoryList.length
          ? data.jobHistoryList
          : Array.isArray(data?.JobHistoryList) && data.JobHistoryList.length
            ? data.JobHistoryList
            : Array.isArray(data?.jobHistory) && data.jobHistory.length
              ? data.jobHistory
              : [];

      this.setState({
        workOrderList: workOrders,
        jobHistoryList: jobHistoryList,
        loading: false,
        fetchingData: false,
        tableView: "purplereport",
      });
    });
  }

  async populateWorkOrderPendingData() {
    this.setState({ fetchingData: true });

    const model = { ...this.state.searchModel };
    const today = moment().format("YYYY-MM-DD");

    const normalizeDate = (value) => {
      if (!value) {
        return value;
      }

      const parsed = moment(value);
      return parsed.isValid() ? parsed.format("YYYY-MM-DD") : value;
    };

    model.StartDate = normalizeDate(model.StartDate) || today;
    model.EndDate = normalizeDate(model.EndDate);

    this.setState(
      (prevState) => ({
        searchModel: {
          ...prevState.searchModel,
          StartDate: model.StartDate,
          EndDate: model.EndDate,
        },
      }),
      () => {
        FetchData(
          "/getpendingsantosworkorders",
          "POST",
          this.user.token,
          model,
        ).then((data) => {
          this.setState({
            workOrderList: data,
            loading: false,
            fetchingData: false,
            tableView: "pending",
          });
        });
      },
    );
  }

  async populateWorkOrderFinalConfirmationData() {
    this.setState({ fetchingData: true });

    let model = { ...this.state.searchModel };
    const normalizeDate = (value) => {
      if (!value) {
        return value;
      }

      const parsed = moment(value);
      return parsed.isValid() ? parsed.format("YYYY-MM-DD") : value;
    };

    model.StartDate = normalizeDate(model.StartDate);
    model.EndDate = normalizeDate(model.EndDate);

    await FetchData(
      "/getfinalconfirmationworkorders",
      "POST",
      this.user.token,
      model,
    ).then((data) => {
      this.setState({
        workOrderList: data,
        loading: false,
        fetchingData: false,
        tableView: "finalconf",
      });
    });
  }

  async populateWorkOrderRemoteData() {
    this.setState({ fetchingData: true });

    const normalizeDate = (value) => {
      if (!value) {
        return null;
      }

      const parsed = moment(value);
      return parsed.isValid() ? parsed.format("YYYY-MM-DD") : value;
    };

    const model = {
      ...this.state.searchModel,
      StartDate: normalizeDate(this.state.searchModel.StartDate),
      EndDate: normalizeDate(this.state.searchModel.EndDate),
    };

    this.setState({ searchModel: model }, () => {
      FetchData("/getremoteworkorders", "POST", this.user.token, model).then(
        (data) => {
          const safeData = Array.isArray(data) ? data : [];
          this.setState({
            workOrderList: safeData,
            loading: false,
            fetchingData: false,
            tableView: "remote",
          });
        },
      );
    });
  }

  async populateWorkOrderCallbackData() {
    this.setState({ fetchingData: true });

    let model = {};
    model = this.state.searchModel;
    const normalizeDate = (value) => {
      if (!value) {
        return value;
      }

      const parsed = moment(value);
      return parsed.isValid() ? parsed.format("YYYY-MM-DD") : value;
    };

    model.StartDate = normalizeDate(model.StartDate);
    model.EndDate = normalizeDate(model.EndDate);

    FetchData("/getcallbackworkorders", "POST", this.user.token, model).then(
      (data) => {
        this.setState({
          workOrderList: data,
          loading: false,
          fetchingData: false,
          tableView: "callback",
        });
      },
    );
  }

  async populateExecutiveUsers() {
    var model = {
      DisabledFlg: false,
      InternalUsers: true,
    };
    //this.setState({ searchModel: model }, () => {
    FetchData("/getusers", "POST", this.user.token, model).then((data) => {
      this.setState({ executiveUsers: data });
    });
    //});

    this.resetChecks();
  }

  renderWorkOrderTableDefault(workOrders) {
    return (
      <WorkOrderTableDefault
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        workOrders={workOrders}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        unCheckAll={this.unCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        openInterpreter={this.openInterpreter}
        onSortedData={this.handleSortedData}
      ></WorkOrderTableDefault>
    );
  }

  renderWorkOrderTableBooking(workOrders) {
    return (
      <WorkOrderTableBooking
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        workOrders={workOrders}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        unCheckAll={this.unCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        openInterpreter={this.openInterpreter}
        onSortedData={this.handleSortedData}
      ></WorkOrderTableBooking>
    );
  }

  renderWorkOrderTableAuthTransport(workOrders) {
    return (
      <WorkOrderTableAuthTransport
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        workOrders={workOrders}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        unCheckAll={this.unCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        openInterpreter={this.openInterpreter}
        onSortedData={this.handleSortedData}
      ></WorkOrderTableAuthTransport>
    );
  }

  renderWorkOrderTableConfirmation(workOrders) {
    return (
      <WorkOrderTableConfirmation
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        workOrders={workOrders}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        unCheckAll={this.unCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        openInterpreter={this.openInterpreter}
        onSortedData={this.handleSortedData}
      ></WorkOrderTableConfirmation>
    );
  }

  renderWorkOrderTableRemote(workOrders) {
    return (
      <WorkOrderTableRemote
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        workOrders={workOrders}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        unCheckAll={this.unCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        openInterpreter={this.openInterpreter}
        onSortedData={this.handleSortedData}
      ></WorkOrderTableRemote>
    );
  }
  renderWorkOrderTableMyJobs(workOrders) {
    return (
      <WorkOrderTableMyJobs
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        workOrders={workOrders}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        unCheckAll={this.unCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        openInterpreter={this.openInterpreter}
        onSortedData={this.handleSortedData}
      ></WorkOrderTableMyJobs>
    );
  }

  renderWorkOrderTablePurpleReport(workOrders) {
    return (
      <WorkOrderTablePurpleReport
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        workOrders={workOrders}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        openInterpreter={this.openInterpreter}
        onSortedData={this.handleSortedData}
        onJobHistoryLoadingChange={this.handlePurpleHistoryLoadingChange}
        jobHistoryList={this.state.jobHistoryList}
      ></WorkOrderTablePurpleReport>
    );
  }

  renderWorkOrderTablePending(workOrders) {
    return (
      <WorkOrderTablePending
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        workOrders={workOrders}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        openInterpreter={this.openInterpreter}
        onSortedData={this.handleSortedData}
      ></WorkOrderTablePending>
    );
  }

  renderWorkOrderTableFinalConfirmation(workOrders) {
    return (
      <WorkOrderTableFinalConfirmation
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        workOrders={workOrders}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        handleIntConfNo={this.handleIntConfNo}
        handleSendSMS={this.handleSendSMS}
        openInterpreter={this.openInterpreter}
        onSortedData={this.handleSortedData}
      ></WorkOrderTableFinalConfirmation>
    );
  }

  renderWorkOrderTableCallback(workOrders) {
    return (
      <WorkOrderTableCallback
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        workOrders={workOrders}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        handleIntConfNo={this.handleIntConfNo}
        handleSendSMS={this.handleSendSMS}
        openInterpreter={this.openInterpreter}
        onSortedData={this.handleSortedData}
      ></WorkOrderTableCallback>
    );
  }

  renderWorkOrderTableContract(workOrders) {
    return (
      <WorkOrderTableContract
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        workOrders={workOrders}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        handleIntCheckin={this.handleIntCheckin}
        handleIntConfNo={this.handleIntConfNo}
        handleSendSMS={this.handleSendSMS}
        openInterpreter={this.openInterpreter}
        onSortedData={this.handleSortedData}
      ></WorkOrderTableContract>
    );
  }

  renderWorkOrderTableAudit(workOrders) {
    return (
      <WorkOrderTableAudit
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        workOrders={workOrders}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        handleIntConfNo={this.handleIntConfNo}
        handleSendSMS={this.handleSendSMS}
        openInterpreter={this.openInterpreter}
        onSortedData={this.handleSortedData}
      ></WorkOrderTableAudit>
    );
  }

  renderWorkOrderTableDeletedJobs(deletedJobs) {
    return (
      <WorkOrderTableDeletedJobs
        state={this.state}
        clearSelection={this.state.clearSelection}
        isMyJob={this.props.isMyJob}
        deletedJobs={deletedJobs}
        searchModel={this.state.searchModel}
        selectedIndex={this.state.selectedIndex}
        requestSort={this.requestSort}
        setData={this.setData}
        setJobData={this.setJobData}
        handleCheckChange={this.handleCheckChange}
        checkAll={this.checkAll}
        handleCheckAll={this.handleCheckAll}
        setModal={this.setModal}
        setInterpreterEmail={this.setInterpreterEmail}
        setRepEmail={this.setRepEmail}
        setRepEmail2={this.setRepEmail2}
        setProviderEmail={this.setProviderEmail}
        viewInvoice={this.viewInvoice}
        addSchedule={this.addSchedule}
        viewJobNotes={this.viewJobNotes}
        handleIntConfNo={this.handleIntConfNo}
        handleSendSMS={this.handleSendSMS}
        openInterpreter={this.openInterpreter}
        viewJobHistory={this.viewJobHistory}
        onSortedData={this.handleSortedDeletedJobs}
      ></WorkOrderTableDeletedJobs>
    );
  }

  setFetchingData(fetching) {
    this.setState({ fetchingData: fetching });
  }

  /// <summary>
  /// Dynamically renders different types of work order tables based on the current table view state.
  /// This method checks if the component is in a loading state and displays a loading message if true.
  /// Otherwise, it selects the appropriate rendering function from a set of predefined functions based on the current table view type.
  /// If the table view type does not match any predefined types, it defaults to rendering the default work order table.
  /// </summary>
  /// <returns>
  /// Returns a JSX element representing the appropriate work order table or a loading indicator.
  /// </returns>
  renderContent() {
    const { loading, tableView, workOrderList, deletedJobsList } = this.state;
    if (loading) {
      return (
        <p>
          <em>Loading...</em>
        </p>
      );
    }

    const tableRenderers = {
      default: () => this.renderWorkOrderTableDefault(workOrderList),
      piggyback: () => this.renderWorkOrderTableDefault(workOrderList),
      autopay: () => this.renderWorkOrderTableDefault(workOrderList),
      auth_transport: () =>
        this.renderWorkOrderTableAuthTransport(workOrderList),
      booking: () => this.renderWorkOrderTableBooking(workOrderList),
      confirmation: () => this.renderWorkOrderTableConfirmation(workOrderList),
      purplereport: () => this.renderWorkOrderTablePurpleReport(workOrderList),
      pending: () => this.renderWorkOrderTablePending(workOrderList),
      finalconf: () =>
        this.renderWorkOrderTableFinalConfirmation(workOrderList),
      myjobs: () => this.renderWorkOrderTableMyJobs(workOrderList),
      callback: () => this.renderWorkOrderTableCallback(workOrderList),
      deletedjobs: () => this.renderWorkOrderTableDeletedJobs(deletedJobsList),
      contract: () => this.renderWorkOrderTableContract(workOrderList),
      audit: () => this.renderWorkOrderTableAudit(workOrderList),
      remote: () => this.renderWorkOrderTableRemote(workOrderList),
    };
    return (tableRenderers[tableView] || tableRenderers["default"])();
  }

  static defaultProps = {
    hidePiggyback: false,
  };

  render() {
    const { alert, tableView } = this.state;
    const contents = this.renderContent(); // This is your table markup

    return (
      <div
        ref={this.containerRef}
        style={{ paddingTop: "12px", overflowX: "hidden", overflowY: "auto" }}
      >
        <center>
          <Alert color={alert.color} isOpen={alert.isOpen}>
            {alert.message}
          </Alert>
        </center>

        {/* First row of buttons */}
        <Row>
          <Col>
            <div style={{ whiteSpace: "nowrap", overflowX: "auto" }}>
              {/* Example: Buttons for tableView toggles */}
              {tableView !== "callback" &&
                tableView !== "deletedjobs" &&
                tableView !== "myjobs" && (
                  <Fragment>
                    {!this.props.hidePiggyback && (
                      <Fragment>
                        <Button
                          color="secondary"
                          outline={tableView !== "piggyback"} // active vs. inactive look
                          onClick={this.handlePiggyBack}
                          className="btn"
                          size="sm"
                        >
                          PiggyBack
                        </Button>
                        <span style={{ paddingRight: "1px" }} />
                      </Fragment>
                    )}

                    {tableView === "autopay" ? (
                      <Fragment>
                        <Button
                          color="secondary"
                          onClick={this.handleAutoPay}
                          className="btn"
                          size="sm"
                        >
                          AutoPay
                        </Button>
                        <span style={{ paddingRight: "1px" }}></span>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <Button
                          color="secondary"
                          outline
                          onClick={this.handleAutoPay}
                          className="btn"
                          size="sm"
                        >
                          AutoPay
                        </Button>
                        <span style={{ paddingRight: "1px" }}></span>
                      </Fragment>
                    )}
                  </Fragment>
                )}

              {tableView !== "callback" && tableView !== "deletedjobs" && (
                <Fragment>
                  <Button
                    color="secondary"
                    outline
                    className="btn"
                    size="sm"
                    onClick={this.handleRepEmailClick}
                  >
                    Rep Email
                  </Button>
                  <span style={{ paddingRight: "1px" }}></span>
                  <Button
                    color="secondary"
                    outline
                    className="btn"
                    size="sm"
                    onClick={this.handleRepAuthorizationsClick}
                  >
                    Rep Authorizations
                  </Button>
                  <span style={{ paddingRight: "1px" }}></span>
                  <Button
                    color="secondary"
                    outline
                    className="btn"
                    size="sm"
                    onClick={this.handleIntEmailClick}
                  >
                    Int Email
                  </Button>
                  <span style={{ paddingRight: "1px" }}></span>
                </Fragment>
              )}

              {tableView !== "callback" &&
                tableView !== "deletedjobs" &&
                tableView !== "myjobs" && (
                  <Fragment>
                    <Button
                      color="secondary"
                      outline
                      className="btn"
                      size="sm"
                      onClick={this.handleCopyJob}
                    >
                      Copy Job
                    </Button>
                    <span style={{ paddingRight: "1px" }}></span>
                  </Fragment>
                )}

              {tableView !== "callback" && tableView !== "deletedjobs" && (
                <Fragment>
                  <Button
                    color="secondary"
                    outline
                    className="btn"
                    size="sm"
                    onClick={this.handleAddJobNoteClick}
                  >
                    Add Job Notes
                  </Button>
                  <span style={{ paddingRight: "1px" }}></span>
                </Fragment>
              )}
              {tableView === "purplereport" &&
                this.state.purpleJobHistoryLoading && (
                  <div
                    className="wo-loading-badge wo-loading-inline wo-loading-offset"
                    aria-live="polite"
                    role="status"
                  >
                    Loading Job History
                  </div>
                )}
            </div>
          </Col>
        </Row>

        {/* Blank spacer row */}
        <Row>
          <Col>
            <div style={{ height: "10px" }} />
          </Col>
        </Row>

        {/* Second row for input fields */}
        <Row>
          <Col className="col-10">
            <div
              style={{
                minWidth: "1300px",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <InputGroup size="sm">
                {tableView !== "callback" && tableView !== "deletedjobs" && (
                  <Button color="btn" onClick={this.resetFields} size="sm">
                    <img
                      src={AddIcon}
                      style={{ width: "16px", height: "16px" }}
                      alt="Add"
                    />{" "}
                    New
                  </Button>
                )}
                <Button color="btn" onClick={this.refreshSearch} size="sm">
                  <img
                    src={RefreshIcon}
                    style={{ width: "16px", height: "16px" }}
                    alt="Refresh"
                  />
                </Button>

                {tableView !== "callback" && tableView !== "myjobs" ? (
                  <Fragment>
                    {tableView !== "callback" &&
                      tableView !== "deletedjobs" && (
                        <Fragment>
                          <Button
                            color="btn"
                            onClick={() => this.handlePrevNextButton(-1)}
                            size="sm"
                          >
                            <img
                              src={Previous}
                              style={{ width: "16px", height: "16px" }}
                              alt="Prev"
                            />
                          </Button>
                          <Button
                            color="btn"
                            onClick={() => this.handlePrevNextButton(1)}
                            size="sm"
                          >
                            <img
                              src={Next}
                              style={{ width: "16px", height: "16px" }}
                              alt="Next"
                            />
                          </Button>
                        </Fragment>
                      )}
                    <input
                      name="MultiFilter"
                      type="checkbox"
                      defaultChecked={this.state.multiFilter}
                      onChange={() =>
                        this.setState({
                          multiFilter: !this.state.multiFilter,
                        })
                      }
                    />
                    <span style={{ paddingRight: "4px" }}></span>

                    <input
                      name="JobNum"
                      ref={(input) => {
                        this.JobNum = input;
                      }}
                      type="number"
                      className="form-control form-control-text"
                      value={this.state.searchModel.JobNum || ""}
                      onChange={this.handleSearchChange}
                      onFocus={this.handleSearchFocus}
                      placeholder="Job #"
                      onKeyDown={this.handleKeyDown}
                    />

                    <input
                      name="StartDate"
                      max={"9999-12-31"}
                      ref={(ref) => (this.txtStartDate = ref)}
                      type="date"
                      className="form-control form-control-text"
                      style={{ width: "50px", height: "26px" }}
                      value={this.state.searchModel.StartDate || ""}
                      onChange={this.handleSearchChange}
                      onFocus={this.handleSearchFocus}
                      onBlur={this.handleSearchBlur}
                      placeholder="Start Date"
                      onKeyDown={this.handleKeyDown}
                    />

                    <input
                      name="EndDate"
                      max={"9999-12-31"}
                      ref={(input) => {
                        this.EndDate = input;
                      }}
                      type="date"
                      className="form-control form-control-text"
                      style={{ width: "50px", height: "26px" }}
                      value={this.state.searchModel.EndDate || ""}
                      onChange={this.handleSearchChange}
                      onFocus={this.handleSearchFocus}
                      onBlur={this.handleSearchBlur}
                      placeholder="End Date"
                      onKeyDown={this.handleKeyDown}
                    />

                    <input
                      name="Claimant"
                      ref={(input) => {
                        this.Claimant = input;
                      }}
                      type="text"
                      className="form-control form-control-text"
                      value={this.state.searchModel.Claimant || ""}
                      onChange={this.handleSearchChange}
                      onFocus={this.handleSearchFocus}
                      placeholder="Claimant"
                      onKeyDown={this.handleKeyDown}
                    />

                    <input
                      name="ClmClaimNumberNoDash"
                      ref={(input) => {
                        this.ClmClaimNumberNoDash = input;
                      }}
                      type="text"
                      className="form-control form-control-text"
                      value={this.state.searchModel.ClmClaimNumberNoDash || ""}
                      onChange={this.handleSearchChange}
                      onFocus={this.handleSearchFocus}
                      placeholder="Claimant #"
                      onKeyDown={this.handleKeyDown}
                    />

                    <input
                      name="CLMPhone"
                      ref={(input) => {
                        this.CLMPhone = input;
                      }}
                      type="text"
                      className="form-control form-control-text"
                      value={this.state.searchModel.CLMPhone || ""}
                      onChange={this.handleSearchChange}
                      onFocus={this.handleSearchFocus}
                      placeholder="CLM Phone"
                      onKeyDown={this.handleKeyDown}
                    />

                    <input
                      name="Interpreter"
                      ref={(input) => {
                        this.Interpreter = input;
                      }}
                      type="text"
                      className="form-control form-control-text"
                      value={this.state.searchModel.Interpreter || ""}
                      onChange={this.handleSearchChange}
                      onFocus={this.handleSearchFocus}
                      placeholder="Interpreter"
                      onKeyDown={this.handleKeyDown}
                    />

                    <input
                      name="Rep"
                      ref={(input) => {
                        this.Rep = input;
                      }}
                      type="text"
                      className="form-control form-control-text"
                      value={this.state.searchModel.Rep || ""}
                      onChange={this.handleSearchChange}
                      onFocus={this.handleSearchFocus}
                      placeholder="Rep"
                      onKeyDown={this.handleKeyDown}
                    />

                    <input
                      name="ClientAbbrv"
                      ref={(input) => {
                        this.ClientAbbrv = input;
                      }}
                      type="text"
                      className="form-control form-control-text"
                      value={this.state.searchModel.ClientAbbrv || ""}
                      onChange={this.handleSearchChange}
                      onFocus={this.handleSearchFocus}
                      placeholder="Client Abbrv"
                      onKeyDown={this.handleKeyDown}
                    />

                    <input
                      name="ProviderName"
                      ref={(input) => {
                        this.ProviderName = input;
                      }}
                      type="text"
                      className="form-control form-control-text"
                      value={this.state.searchModel.ProviderName || ""}
                      onChange={this.handleSearchChange}
                      onFocus={this.handleSearchFocus}
                      placeholder="Job Provider"
                      onKeyDown={this.handleKeyDown}
                    />
                  </Fragment>
                ) : (
                  ""
                )}

                {tableView === "deletedjobs" && (
                  <Fragment>
                    <Button
                      color="btn"
                      onClick={this.confirmActivation}
                      size="sm"
                    >
                      Activate
                    </Button>
                  </Fragment>
                )}

                {this.props.isMyJob && (
                  <span style={{ padding: "6px" }}>User: </span>
                )}
                {this.props.isMyJob && (
                  <Col className="col-2">
                    <select
                      name="MyJobsUserId"
                      className="form-control form-control-text"
                      value={this.state.searchModel.MyJobsUserId} // <-- userID goes here
                      onChange={this.handleSearchChange}
                    >
                      <option value=""></option>
                      {this.state.executiveUsers.map((usr) => (
                        <option key={usr.userId} value={usr.userId}>
                          {usr.firstName} {usr.lastName}
                        </option>
                      ))}
                    </select>
                  </Col>
                )}
              </InputGroup>
            </div>
          </Col>
        </Row>

        {/* Show the loading modal if needed */}
        <LoadingModal fetchingData={this.state.fetchingData} />

        <ReactTooltip id="rtp" place="right" type="dark" effect="solid" html />

        {/* 
          Only the table portion scrolls.
          This container has a fixed maxHeight (600px here as an example).
        */}
        <div
          style={{ display: "flex", flexDirection: "column", height: "750px" }}
        >
          {contents}
        </div>

        {/* Row to show how many items we have, remains fixed below table */}
        <Row>
          <Col>
            <InputGroup size="sm">
              <p
                style={{
                  paddingLeft: "60px",
                  paddingTop: "10px",
                  fontWeight: "bold",
                }}
              >
                {this.state.deletedJobsList &&
                this.state.deletedJobsList.length > 0
                  ? this.state.deletedJobsList.length
                  : this.state.workOrderList.length}
              </p>
            </InputGroup>
          </Col>
        </Row>

        {/* Your modals remain below and do not scroll with the table */}
        {this.state.modal && (
          <WorkOrderForm
            model={this.state.model}
            isFollowup={this.state.isFollowup}
            followupOriginJobId={this.state.followupOriginjobId}
            modal={this.state.modal}
            alert={this.state.alert}
            setModal={this.setModal}
            onModelChange={this.handleWorkOrderModelChange}
            refreshWorkOrderData={this.refreshWorkOrderData}
            workOrderList={this.state.workOrderList}
            jobHistoryList={this.state.jobHistoryList}
            jobInvLineList={this.state.jobInvLineList}
            setNextPrevData={this.setNextPrevData}
            selectedIndex={this.state.selectedIndex}
            handleSaveEventSuccess={this.handleSaveEventSuccess}
            tableView={this.state.tableView}
            setFetchingData={this.setFetchingData}
            viewInvoice={this.viewInvoice}
          />
        )}

        {this.state.modalIntFormEmail && (
          <InterpreterFormEmail
            model={this.state.email}
            job={this.state.selectedJob}
            modal={this.state.modalIntFormEmail}
            showButtons={this.state.showButtons}
            alert={this.state.alert}
            setModal={this.setModalIntFormEmail}
            handleSaveEventSuccess={this.handleSaveEventIntEmailSuccess}
            onCoveringEmailSent={this.handleCoveringEmailSent}
            onClose={this.handleClearChecksOnEmailModalClose}
          />
        )}
        {this.state.modalRepFormEmail && (
          <RepFormEmail
            model={this.state.email}
            job={this.state.selectedJob}
            modal={this.state.modalRepFormEmail}
            alert={this.state.alert}
            setModal={this.setModalRepFormEmail}
            handleSaveEventSuccess={this.handleSaveEventRepEmailSuccess}
            isOpen={this.state.modalRepFormEmail}
            onClose={this.handleClearChecksOnEmailModalClose}
          />
        )}
        {this.state.modalProviderFormEmail && (
          <ProviderFormEmail
            model={this.state.email}
            job={this.state.selectedJob}
            modal={this.state.modalProviderFormEmail}
            alert={this.state.alert}
            setModal={this.setModalProviderFormEmail}
            handleSaveEventSuccess={this.handleSaveEventProviderEmailSuccess}
            onClose={this.handleClearChecksOnEmailModalClose}
          />
        )}
        {this.state.modalWOJobNotes && (
          <WorkOrderJobNotes
            receivableList={this.state.receivableList}
            receivableItemList={this.state.receivableItemList}
            modal={this.state.modalWOJobNotes}
            alert={this.state.alert}
            setModal={this.setModalWOJobNotes}
          />
        )}
        {this.state.modalEmailConfirm && (
          <WorkOrderIntConfNo
            modal={this.state.modalEmailConfirm}
            alert={this.state.alert}
            setModal={this.setModalEmailConfirm}
            notify_type={this.state.emailConfirm.notify_type}
            JobId={this.state.emailConfirm.JobId}
            IntId={this.state.emailConfirm.IntId}
            handleSaveEventSuccess={this.handleSaveEventEmailConfirmSuccess}
            onClose={this.handleClearChecksOnEmailModalClose}
          />
        )}
        {this.state.modalInterpreter && (
          <InterpreterForm
            model={this.state.interpreter}
            modal={this.state.modalInterpreter}
            alert={this.state.alert}
            setModal={this.setModalInterpreter}
            handleSaveEventSuccess={this.handleSaveEventInterpreterSuccess}
          />
        )}
        {this.state.modalAddJobNote && (
          <WorkOrderAddJobNotes
            model={this.state.jobNotes}
            modal={this.state.modalAddJobNote}
            alert={this.state.alert}
            setModal={this.setModalAddJobNote}
            handleSaveEventSuccess={this.handleSaveEventJobNotesSuccess}
            setFetchingData={() => {}}
          />
        )}
        {this.state.modalCopyJob && (
          <WorkOrderCopyJob
            model={this.state.model}
            modal={this.state.modalCopyJob}
            alert={this.state.alert}
            setModal={this.setModalCopyJob}
            handleSaveEventSuccess={this.handleSaveEventCopyJobSuccess}
          />
        )}
      </div>
    );
  }
}
